/* eslint-disable */

export interface ITranslations {
	'en': string;
	'header.searchPlaceholder': string;
	'header.products': string;
	'header.search': string;
	'header.clearSearch': string;
	'header.physicalStoreMode': string;
	'header.cartFromDifferentWarehouse': string;
	'header.searchLabel': string;
	'footer.followUs': string;
	'footer.seeCookieConsent': string;
	'actionMenu.myPage': string;
	'actionMenu.myOrders': string;
	'actionMenu.myFavourites': string;
	'actionMenu.prescriptionHistory': string;
	'actionMenu.logIn': string;
	'actionMenu.register': string;
	'actionMenu.logOut': string;
	'actionMenu.activeBankIdSession': string;
	'actionMenu.logOutFromBankId': string;
	'actionMenu.customerService': string;
	'actionMenu.rxService': string;
	'homePage.title': string;
	'common.tryAgainOrContactCustomerSupport': string;
	'navigation.menu': string;
	'navigation.rxMenu': string;
	'navigation.myPage': string;
	'navigation.cart': string;
	'navigation.favourites': string;
	'navigation.categories': string;
	'navigation.categoriesAndProducts': string;
	'navigation.shortcuts': string;
	'navigation.buyPrescription': string;
	'navigation.chatWithPharmacist': string;
	'navigation.logIn': string;
	'navigation.logOut': string;
	'navigation.hi': string;
	'navigation.registrationLink': string;
	'navigation.open': string;
	'navigation.close': string;
	'navigation.back': string;
	'navigation.seeAllProducts': string;
	'navigation.physicalStoreMode': string;
	'navigation.skipToContent': string;
	'navigation.goToCheckout': string;
	'navigation.search': string;
	'favourites.removed': string;
	'favourites.login': string;
	'favourites.register': string;
	'favourites.loginRequiredHeader': string;
	'favourites.loginRequiredContent': string;
	'favourites.saveItems': string;
	'favourites.description': string;
	'favourites.seeAllProducts': string;
	'favourites.productRemoved': string;
	'favourites.added': string;
	'favourites.firstFavouriteHeading': string;
	'favourites.firstFavouriteContent': string;
	'favourites.goToFavourites': string;
	'favourites.addToFavourites': string;
	'favourites.removeFromFavourites': string;
	'newMessage.heading': string;
	'newMessage.content': string;
	'newMessage.link': string;
	'expectedDeliveryDate.estimatedDeliveryTo': string;
	'expectedDeliveryDate.deliveryDate': string;
	'expectedDeliveryDate.deliveryTo': string;
	'expectedDeliveryDate.delivery': string;
	'expectedDeliveryDate.deliveryToInfo': string;
	'expectedDeliveryDate.change': string;
	'expectedDeliveryDate.info': string;
	'expectedDeliveryDate.postalCode': string;
	'expectedDeliveryDate.checkDeliveryDate': string;
	'expectedDeliveryDate.check': string;
	'expectedDeliveryDate.preferredMethod': string;
	'expectedDeliveryDate.fastestMethod': string;
	'expectedDeliveryDate.allMethods': string;
	'expectedDeliveryDate.failPostalCode': string;
	'expectedDeliveryDate.seeMore': string;
	'expectedDeliveryDate.notAvailable': string;
	'expectedDeliveryDate.aboutDeliveryMethods': string;
	'expectedDeliveryDate.noMethods.title': string;
	'expectedDeliveryDate.noMethods.subtitle': string;
	'expectedDeliveryDate.unexpectedError.title': string;
	'expectedDeliveryDate.unexpectedError.subtitle': string;
	'expectedDeliveryDate.today': string;
	'expectedDeliveryDate.tomorrow': string;
	'brand.favourite': string;
	'brand.popular': string;
	'brand.brands': string;
	'cartSummary.addedToCart': string;
	'cartSummary.itemsInYourCart': string;
	'cartSummary.cart': string;
	'cartSummary.prescription': string;
	'cartSummary.closeCart': string;
	'cartSummary.openCart': string;
	'cartSummary.product': string;
	'cartSummary.products': string;
	'cartSummary.freeShipping': string;
	'cartSummary.totalSum': string;
	'cartSummary.spared': string;
	'cartSummary.goToCart': string;
	'cartSummary.goToCheckout': string;
	'cartSummary.loginTitle': string;
	'cartSummary.loginSubtitle': string;
	'cartSummary.loginButton': string;
	'cartSummary.registerTitle': string;
	'cartSummary.registerSubtitle': string;
	'cartSummary.registerButton': string;
	'cartSummary.vippsTitle': string;
	'cartSummary.vippsSubtitle': string;
	'cartSummary.vippsButton': string;
	'cartSummary.emptyCartHeading': string;
	'cartSummary.emptyCartMessage': string;
	'cartSummary.includingTaxes': string;
	'cartSummary.remove': string;
	'cartSummary.addToCartMessage': string;
	'cartSummary.discount': string;
	'cartSummary.delivery': string;
	'cartSummary.free': string;
	'cartSummary.from': string;
	'cartSummary.freeDeliveryNeededAmount': string;
	'cartSummary.freeDeliveryGratis': string;
	'cartSummary.freeDeliveryAchieved': string;
	'cartSummary.freeDeliveryCalculationHeading': string;
	'cartSummary.freeDeliveryButtonA11yText': string;
	'cartSummary.freeDeliveryButtonHide': string;
	'cartSummary.freeDeliveryButtonShow': string;
	'cartSummary.completePurchase': string;
	'cartSummary.completePurchaseForFreeDelivery': string;
	'cartSummary.merged': string;
	'cartSummary.increaseQuantity': string;
	'cartSummary.decreaseQuantity': string;
	'cartSummary.validation.Unexpected': string;
	'cartSummary.validation.CannotProcessDueToMissingOrderStatus': string;
	'cartSummary.validation.RemovedDueToCodeMissing': string;
	'cartSummary.validation.RemovedDueToNotAvailableInMarket': string;
	'cartSummary.validation.RemovedDueToUnavailableCatalog': string;
	'cartSummary.validation.RemovedDueToUnavailableItem': string;
	'cartSummary.validation.RemovedDueToInsufficientQuantityInInventory': string;
	'cartSummary.validation.RemovedDueToInactiveWarehouse': string;
	'cartSummary.validation.RemovedDueToMissingInventoryInformation': string;
	'cartSummary.validation.RemovedDueToInvalidPrice': string;
	'cartSummary.validation.RemovedDueToInvalidMaxQuantitySetting': string;
	'cartSummary.validation.AdjustedQuantityByMinQuantity': string;
	'cartSummary.validation.AdjustedQuantityByMaxQuantity': string;
	'cartSummary.validation.AdjustedQuantityByBackorderQuantity': string;
	'cartSummary.validation.AdjustedQuantityByPreorderQuantity': string;
	'cartSummary.validation.AdjustedQuantityByAvailableQuantity': string;
	'cartSummary.validation.PlacedPricedChanged': string;
	'cartSummary.validation.RemovedGiftDueToInsufficientQuantityInInventory': string;
	'cartSummary.validation.RejectedInventoryRequestDueToInsufficientQuantity': string;
	'cartSummary.validation.AdjustedQuantityByOtcLimitQuantity': string;
	'cartSummary.validation.CannotBeAddedDueToDateTimeRestrictions': string;
	'cartSummary.validation.CannotBeRemovedDueToPriceRecalculationError': string;
	'cartSummary.validation.CannotBeAddedDueToCooledProductsDisabled': string;
	'cartSummary.validation.CannotBeAddedDueToCooledProductsConflict': string;
	'cartSummary.validation.addToCart.unexpectedError': string;
	'cartSummary.validation.invalidActionPleaseRefresh': string;
	'cartSummary.validation.DifferentWarehouse': string;
	'cartSummary.validation.atLeastOneUnavailable': string;
	'cartSummary.validation.quantityUnavailable': string;
	'cartSummary.validation.confirmAvailableQuantity': string;
	'cartSummary.validation.onlyAvailable': string;
	'cartWidget.closeInfo': string;
	'vippsExpress.heading': string;
	'vippsExpress.subheading1': string;
	'vippsExpress.subheading2': string;
	'vippsExpress.phoneNumber': string;
	'vippsExpress.ssn': string;
	'vippsExpress.invalidSsn': string;
	'vippsExpress.button': string;
	'modal.ok': string;
	'modal.confirm': string;
	'modal.cancel': string;
	'modal.close': string;
	'modal.sessionExpired.title': string;
	'modal.sessionExpired.message': string;
	'modal.errorInfo': string;
	'modal.goBack': string;
	'modal.refresh': string;
	'modal.rxSession.goToCheckout': string;
	'modal.rxSession.close': string;
	'modal.rxSession.logIn': string;
	'modal.rxSession.logout': string;
	'modal.rxSession.goToCart': string;
	'modal.rxSession.expiringHeading': string;
	'modal.rxSession.expiredHeading': string;
	'modal.rxSession.logoutHeading': string;
	'modal.rxSession.minute': string;
	'modal.rxSession.minutes': string;
	'modal.rxSession.expiringBody': string;
	'modal.rxSession.expiredBody': string;
	'modal.rxSession.logoutBody': string;
	'modal.cooledProducts.heading': string;
	'modal.cooledProducts.descriptionCooled': string;
	'modal.cooledProducts.descriptionWarm': string;
	'modal.cooledProducts.selectProducts': string;
	'modal.cooledProducts.singleConflictedCooledProduct': string;
	'modal.cooledProducts.singleConflictedWarmProduct': string;
	'modal.cooledProducts.multipleConflictedCooledProducts': string;
	'modal.cooledProducts.multipleConflictedWarmProducts': string;
	'modal.cooledProducts.selectCooledProduct': string;
	'modal.cooledProducts.selectWarmProduct': string;
	'modal.cooledProducts.cooledProductBadge': string;
	'modal.cooledProducts.keep': string;
	'modal.cooledProducts.errors.nothingSelected': string;
	'payment.title': string;
	'payment.addPayment': string;
	'payment.paymentMethods': string;
	'payment.paymentAddress': string;
	'payment.addToAddressBook': string;
	'payment.submit': string;
	'payment.payWithVipps': string;
	'payment.processing': string;
	'payment.pleaseWait': string;
	'payment.payWith': string;
	'payment.klarnaErrorMessage': string;
	'payment.vippsExpressCheckout': string;
	'checkout.name': string;
	'checkout.heading': string;
	'checkout.required': string;
	'checkout.incorrectPostalCode': string;
	'checkout.incorrectEmail': string;
	'checkout.incorrectPhone': string;
	'checkout.incorrectPostalCodeOrCity': string;
	'checkout.incorrectCity': string;
	'checkout.orderHasChangedHeading': string;
	'checkout.orderHasChangedContent': string;
	'checkout.deliveryMethodHasChangedHeading': string;
	'checkout.deliveryMethodHasChangedContent': string;
	'checkout.ok': string;
	'checkout.consentsRequired': string;
	'checkout.termsOfSaleConsent.ingress': string;
	'checkout.termsOfSaleConsent.link': string;
	'checkout.continueShopping': string;
	'checkout.backToCart': string;
	'checkout.paymentSuccess': string;
	'checkout.summary.title': string;
	'checkout.summary.productsInCart': string;
	'checkout.summary.sum': string;
	'checkout.summary.freeDelivery': string;
	'checkout.summary.goToAddresses': string;
	'checkout.summary.goToDelivery': string;
	'checkout.summary.warningTop': string;
	'checkout.summary.warningBottom': string;
	'checkout.summary.discountCode': string;
	'checkout.summary.enterDiscountCode': string;
	'checkout.summary.addCode': string;
	'checkout.summary.discount': string;
	'checkout.summary.delivery': string;
	'checkout.summary.total': string;
	'checkout.summary.includeTax': string;
	'checkout.summary.apologyTechnicalError': string;
	'checkout.summary.add': string;
	'checkout.summary.reviewCart': string;
	'checkout.summary.orderOverview': string;
	'checkout.summary.coupons.genericCouponError': string;
	'checkout.summary.coupons.anonymousCustomerRedemptionError': string;
	'checkout.summary.coupons.alreadyUsedError': string;
	'checkout.summary.coupons.couponEmpty': string;
	'checkout.summary.coupons.couponTechnicalError': string;
	'checkout.summary.coupons.couponWithoutDiscount': string;
	'checkout.summary.coupons.requireRxInCart': string;
	'checkout.summary.coupons.notFoundForUser': string;
	'checkout.summary.coupons.notActiveYet': string;
	'checkout.summary.coupons.expired': string;
	'checkout.summary.coupons.removeCoupon': string;
	'checkout.ageConfirmation.InvalidNumber': string;
	'checkout.ageConfirmation.Invalid': string;
	'checkout.ageConfirmation.InvalidAge': string;
	'checkout.ageConfirmation.header': string;
	'checkout.ageConfirmation.info': string;
	'checkout.ageConfirmation.input': string;
	'checkout.ageConfirmation.button': string;
	'checkout.delivery.address': string;
	'checkout.delivery.sendTo': string;
	'checkout.delivery.addAnotherAddress': string;
	'checkout.delivery.method': string;
	'checkout.delivery.hasMedicines': string;
	'checkout.delivery.notAvailableMethod': string;
	'checkout.delivery.readAboutCooledDelivery': string;
	'checkout.delivery.cooledDeliveryNotAvailable': string;
	'checkout.delivery.removeFromCart': string;
	'checkout.delivery.goToPayment': string;
	'checkout.delivery.placeOrder': string;
	'checkout.delivery.delete': string;
	'checkout.delivery.edit': string;
	'checkout.delivery.formAddress': string;
	'checkout.delivery.postalCodeAndCity': string;
	'checkout.delivery.postalCodeAndCityPlaceholder': string;
	'checkout.delivery.companyName': string;
	'checkout.delivery.email': string;
	'checkout.delivery.phoneNumber': string;
	'checkout.delivery.checkPhoneNumber': string;
	'checkout.delivery.firstName': string;
	'checkout.delivery.lastName': string;
	'checkout.delivery.city': string;
	'checkout.delivery.formAdd': string;
	'checkout.delivery.noOpeningHours': string;
	'checkout.delivery.openingHours': string;
	'checkout.delivery.formCancel': string;
	'checkout.delivery.formHeading': string;
	'checkout.delivery.formConfirm': string;
	'checkout.delivery.toThisAddress': string;
	'checkout.delivery.confirmAddressDelete': string;
	'checkout.delivery.acceptBamboraPayments': string;
	'checkout.delivery.postalCode': string;
	'checkout.delivery.search': string;
	'checkout.delivery.invalidPostalCode': string;
	'checkout.delivery.chooseAnotherLocation': string;
	'checkout.delivery.chooseAnotherDate': string;
	'checkout.delivery.selectDeliveryDate': string;
	'checkout.delivery.servicePointNotSelected': string;
	'checkout.delivery.formIsOpen': string;
	'checkout.delivery.addressUnavailable': string;
	'checkout.delivery.addressHasMissingNumberWarning': string;
	'checkout.delivery.line1required': string;
	'checkout.delivery.line1MissingNumber': string;
	'checkout.delivery.noServicePointsAvailable': string;
	'checkout.delivery.firstNameWrongCharacters': string;
	'checkout.delivery.lastNameWrongCharacters': string;
	'checkout.delivery.line1WrongCharacters': string;
	'checkout.delivery.coWrongCharacters': string;
	'checkout.delivery.availableOptions': string;
	'checkout.delivery.showNotAvailableOptions': string;
	'checkout.delivery.unavailableHeading': string;
	'checkout.delivery.unavailableSubheading': string;
	'checkout.delivery.newAddress': string;
	'checkout.delivery.editAddresses': string;
	'checkout.delivery.selectAddress': string;
	'checkout.delivery.noMethodsAvailableHeading': string;
	'checkout.delivery.noMethodsAvailableLine1': string;
	'checkout.delivery.noMethodsAvailableLine2': string;
	'checkout.delivery.noMethodsAvailableReadMore': string;
	'checkout.delivery.instaboxEta': string;
	'checkout.delivery.showMore': string;
	'checkout.delivery.pickupPoints.emptyTitle': string;
	'checkout.delivery.pickupPoints.emptySubtitle': string;
	'checkout.delivery.pickupPoints.noConnectionTitle': string;
	'checkout.delivery.pickupPoints.noConnectionSubtitle': string;
	'checkout.delivery.days.monday': string;
	'checkout.delivery.days.tuesday': string;
	'checkout.delivery.days.wednesday': string;
	'checkout.delivery.days.thursday': string;
	'checkout.delivery.days.friday': string;
	'checkout.delivery.days.saturday': string;
	'checkout.delivery.days.sunday': string;
	'checkout.delivery.daysLong.monday': string;
	'checkout.delivery.daysLong.tuesday': string;
	'checkout.delivery.daysLong.wednesday': string;
	'checkout.delivery.daysLong.thursday': string;
	'checkout.delivery.daysLong.friday': string;
	'checkout.delivery.daysLong.saturday': string;
	'checkout.delivery.daysLong.sunday': string;
	'checkout.delivery.today': string;
	'checkout.delivery.closed': string;
	'checkout.delivery.tomorrow': string;
	'checkout.shippingMethodAvailability.AddressNotSelected': string;
	'checkout.shippingMethodAvailability.DeliveryMethodNotSelected': string;
	'checkout.shippingMethodAvailability.InvalidDimensions': string;
	'checkout.shippingMethodAvailability.MailboxNotEligible': string;
	'checkout.shippingMethodAvailability.PorterBuddyAddressNotSupported': string;
	'checkout.shippingMethodAvailability.PorterBuddyNotAvailable': string;
	'checkout.shippingMethodAvailability.HeltHjemNotAvailable': string;
	'checkout.shippingMethodAvailability.PostNHomeNotAvailable': string;
	'checkout.shippingMethodAvailability.PostNPickNotAvailable': string;
	'checkout.shippingMethodAvailability.PostNPickLockersNotAvailable': string;
	'checkout.shippingMethodAvailability.PorterBuddyWindowNotSelected': string;
	'checkout.shippingMethodAvailability.PostNordServicePointNotAvailable': string;
	'checkout.shippingMethodAvailability.InstaBoxExpressNotAvailable': string;
	'checkout.shippingMethodAvailability.InstaBoxHomeNotAvailable': string;
	'checkout.shippingMethodAvailability.PostNordServicePointNotSelected': string;
	'checkout.shippingMethodAvailability.InstaBoxParcelLockerNotSelected': string;
	'checkout.shippingMethodAvailability.GordonTimeWindowNotSelected': string;
	'checkout.shippingMethodAvailability.GordonNotAvailable': string;
	'checkout.shippingMethodAvailability.NotAvailable': string;
	'checkout.shippingMethodAvailability.BadTemperatures': string;
	'checkout.shippingMethodAvailability.AirmeeHomeNotAvailable': string;
	'checkout.shippingMethodAvailability.AirmeeHomeNotSelected': string;
	'checkout.shippingMethodAvailability.OtcNotAvailable': string;
	'checkout.shippingMethodAvailability.RxNotAvailable': string;
	'checkout.shippingMethodAvailability.HeltHjemServicePointNotAvailable': string;
	'checkout.shippingMethodAvailability.HeltHjemServicePointNotSelected': string;
	'checkout.validation.couldNotSave': string;
	'checkout.validation.ValidationFailed': string;
	'checkout.validation.OrderAdjustedAfterValidation': string;
	'checkout.validation.PriceChangedAfterValidation': string;
	'checkout.validation.PriceMismatch': string;
	'checkout.validation.InvalidDeliveryServiceLocation': string;
	'checkout.validation.ItemsRemovedAfterInventoryValidation': string;
	'checkout.validation.PaymentFailed': string;
	'checkout.validation.MissingDeliveryMethod': string;
	'checkout.validation.InvalidShippingAddress': string;
	'checkout.validation.UnexpectedError': string;
	'checkout.validation.PaymentCancelled': string;
	'checkout.validation.IncorrectFirstName': string;
	'checkout.validation.IncorrectLastName': string;
	'checkout.validation.IncorrectPostalCode': string;
	'checkout.validation.IncorrectCity': string;
	'checkout.validation.MissingAddress': string;
	'checkout.validation.IncorrectLine1': string;
	'checkout.validation.NullAddress': string;
	'checkout.validation.CannotDeleteLastAddress': string;
	'checkout.validation.AddressDoesNotExists': string;
	'checkout.validation.AddressAlreadyExists': string;
	'checkout.validation.IncorrectPhoneNumber': string;
	'checkout.validation.EmptyPhoneNumber': string;
	'checkout.validation.IncorrectCompany': string;
	'checkout.validation.Other': string;
	'checkout.validation.InvalidDeliveryWindow': string;
	'checkout.validation.ExpressCheckoutInvalidDeliveryWindow': string;
	'checkout.error.generic': string;
	'checkout.error.vippsCancelled': string;
	'checkout.error.errorSettingServicePoint': string;
	'checkout.error.unexpected': string;
	'checkout.error.unexpectedCheckout': string;
	'checkout.error.refresh': string;
	'checkout.error.invalidActionPleaseRefresh': string;
	'checkout.error.invalidDeliveryWindow': string;
	'checkout.notCharged': string;
	'orderSummary.name': string;
	'orderSummary.thankYouHeader': string;
	'orderSummary.emailConfirmation': string;
	'orderSummary.emailConfirmationFallback': string;
	'orderSummary.contactCustomerService': string;
	'orderSummary.customerService': string;
	'orderSummary.orderNumber': string;
	'orderSummary.orderDate': string;
	'orderSummary.deliveryDate': string;
	'orderSummary.orderStatus': string;
	'orderSummary.paymentMethod': string;
	'orderSummary.complaint': string;
	'orderSummary.cancelOrder': string;
	'orderSummary.heading': string;
	'orderSummary.package': string;
	'orderSummary.specialItems': string;
	'orderSummary.sum': string;
	'orderSummary.of': string;
	'orderSummary.before': string;
	'orderSummary.personalPickup': string;
	'orderSummary.deliveryAddress': string;
	'orderSummary.packageTracking': string;
	'orderSummary.cancel': string;
	'orderSummary.delivery': string;
	'orderSummary.freeDelivery': string;
	'orderSummary.discount': string;
	'orderSummary.discountCode': string;
	'orderSummary.replacement': string;
	'orderSummary.priceAdjustment': string;
	'orderSummary.total': string;
	'orderSummary.includeTax': string;
	'orderSummary.summary': string;
	'orderSummary.waitingToBeShipped': string;
	'orderSummary.cancelledProducts': string;
	'orderSummary.productCancelled': string;
	'orderSummary.paymentTypes.card': string;
	'orderSummary.paymentTypes.vipps': string;
	'orderSummary.paymentTypes.other': string;
	'orderSummary.paymentTypes.klarna': string;
	'orderSummary.invoices.notReady': string;
	'orderSummary.invoices.unavailable': string;
	'orderSummary.invoices.invoice': string;
	'orderSummary.rateThisProduct': string;
	'orderSummary.paymentInfo': string;
	'product.related': string;
	'product.interesting': string;
	'product.otherSearchedFor': string;
	'product.before': string;
	'product.prescriptionImageAlt': string;
	'product.myPrescriptions': string;
	'product.notAvailable': string;
	'product.prescriptionMessage': string;
	'product.outOfStockMessage': string;
	'product.notAvailableMessage': string;
	'product.ageOfConsentMessage': string;
	'product.coldProductMessage': string;
	'product.freeDelivery': string;
	'product.deliveryFrom': string;
	'product.validUntil': string;
	'product.explore': string;
	'product.previous': string;
	'product.next': string;
	'product.availabilityNotification.heading': string;
	'product.availabilityNotification.subheading': string;
	'product.availabilityNotification.modalHeading': string;
	'product.availabilityNotification.modalSubheading': string;
	'product.availabilityNotification.button': string;
	'product.availabilityNotification.modalButton': string;
	'product.availabilityNotification.privacyPolicyText': string;
	'product.availabilityNotification.privacyPolicyLink': string;
	'product.availabilityNotification.savedHeading': string;
	'product.availabilityNotification.savedSubheading': string;
	'product.availabilityNotification.incorrectEmail': string;
	'product.availabilityNotification.unexpectedError': string;
	'productAvailability.InStock': string;
	'productAvailability.LowInStock': string;
	'productAvailability.OnDemand': string;
	'productAvailability.NotInStock': string;
	'productAvailability.PhysicalStoreOnly': string;
	'productAvailability.TemporarySalesStop': string;
	'productAvailability.NotInStockRxAdditionalInfo': string;
	'productAvailability.NotInStockNonRxRefundedAdditionalInfo': string;
	'productAvailability.OrderedRxAdditionalInfo': string;
	'unavailabilityReason.Ok': string;
	'unavailabilityReason.StatusNotWebReady': string;
	'unavailabilityReason.NoPrice': string;
	'unavailabilityReason.NoWeightOrDimensions': string;
	'unavailabilityReason.NoInventory': string;
	'unavailabilityReason.NotFound': string;
	'unavailabilityReason.WeightExceedsThreshold': string;
	'unavailabilityReason.ExpiredInFarmalogg': string;
	'productCard.before': string;
	'productCard.discount': string;
	'productCard.prescription': string;
	'productInformation.showMore': string;
	'productInformation.prescriptionProduct': string;
	'promotions.discountCodeText': string;
	'promotions.freeItemsDiscountInfoType': string;
	'promotions.quantityItemsDiscountInfoType': string;
	'promotions.quantityItemsDiscountText': string;
	'promotions.defaultDiscountText': string;
	'addToCart.buy': string;
	'addToCart.buyWithGuidance': string;
	'addToCart.formWarning': string;
	'addToCart.errorMessage': string;
	'addToCart.successfullyAdded': string;
	'addToCart.unexpectedError': string;
	'addToCart.close': string;
	'filters.category': string;
	'filters.brand': string;
	'filters.subbrand': string;
	'filters.productType': string;
	'filters.skinType': string;
	'filters.properties': string;
	'filters.form': string;
	'filters.keyInformation': string;
	'filters.audience': string;
	'filters.sunFactor': string;
	'filters.taste': string;
	'filters.size': string;
	'filters.material': string;
	'filters.color': string;
	'filters.strength': string;
	'filters.hairType': string;
	'filters.calories': string;
	'filters.price': string;
	'filters.priceDescription': string;
	'sorting.ByDate': string;
	'sorting.ByNewlyAdded': string;
	'sorting.ByRelevance': string;
	'sorting.ByPriceAscending': string;
	'sorting.ByPriceDescending': string;
	'sorting.ByName': string;
	'sorting.ByPromotionPercentage': string;
	'search.products': string;
	'search.categories': string;
	'search.brands': string;
	'search.seeAll': string;
	'search.noResults': string;
	'search.seeRecommendations': string;
	'search.checkSpelling': string;
	'search.phrases': string;
	'search.pharmacyAdvice': string;
	'productFilters.filters': string;
	'productFilters.open': string;
	'productFilters.product': string;
	'productFilters.products': string;
	'productFilters.loading': string;
	'productFilters.searchResults': string;
	'productFilters.searchResultsWithoutFor': string;
	'productFilters.clear': string;
	'productFilters.seeResults': string;
	'productFilters.noResults': string;
	'productFilters.sortBy': string;
	'paging.previousPage': string;
	'paging.nextPage': string;
	'paging.currentPage': string;
	'paging.of': string;
	'priceRange.from': string;
	'priceRange.to': string;
	'displayAttributes.warranty': string;
	'displayAttributes.productInfo': string;
	'displayAttributes.ingredients': string;
	'displayAttributes.tabletPicture': string;
	'displayAttributes.contentDeclaration': string;
	'displayAttributes.activeIngredient': string;
	'displayAttributes.usageAndDosage': string;
	'displayAttributes.subscriptionLink': string;
	'displayAttributes.manufacturerLink': string;
	'displayAttributes.resourceLink': string;
	'displayAttributes.dosage': string;
	'displayAttributes.precautions': string;
	'displayAttributes.pregnancyNotice': string;
	'displayAttributes.warningSign': string;
	'displayAttributes.canBeShared': string;
	'displayAttributes.nutritionalContent': string;
	'displayAttributes.canBeCrushed': string;
	'displayAttributes.storageConditions': string;
	'displayAttributes.dangerousGoods': string;
	'displayAttributes.leafletLink': string;
	'displayAttributes.flavor': string;
	'displayAttributes.classification': string;
	'displayAttributes.tabletPictureLink': string;
	'displayAttributes.manufacturerLeaflet': string;
	'displayAttributes.productNumber': string;
	'displayAttributes.farmaloggNumber': string;
	'displayAttributes.additionalResource': string;
	'displayAttributes.additionalResourceHeader': string;
	'displayAttributes.yes': string;
	'displayAttributes.no': string;
	'selectedOptionList.removeAll': string;
	'cookiesConsent.acceptButtonLabel': string;
	'mainBanner.readMore': string;
	'alertRibbon.close': string;
	'info.readMore': string;
	'brandPage.readMore': string;
	'brandPage.exploreBrands': string;
	'categoryPage.readMore': string;
	'mainBannerGallery.next': string;
	'mainBannerGallery.previous': string;
	'viagraForm.heading': string;
	'viagraForm.validation': string;
	'viagraForm.gender': string;
	'viagraForm.man': string;
	'viagraForm.woman': string;
	'viagraForm.onlyForMan': string;
	'viagraForm.yes': string;
	'viagraForm.no': string;
	'viagraForm.contactUs': string;
	'viagraForm.discuss': string;
	'viagraForm.anyOfFollowing': string;
	'viagraForm.lowBloodPressure': string;
	'viagraForm.lowBloodPressureExplanation': string;
	'viagraForm.highBloodPressure': string;
	'viagraForm.highBloodPressureExplanation': string;
	'viagraForm.angina': string;
	'viagraForm.anginaExplanation': string;
	'viagraForm.irregularHeartbeats': string;
	'viagraForm.irregularHeartbeatsExplanation': string;
	'viagraForm.anticonvulsantMedicines': string;
	'viagraForm.anticonvulsantMedicinesExplanation': string;
	'viagraForm.readMoreAboutHeartCramps': string;
	'viagraForm.heartAttack': string;
	'viagraForm.heartAttackExplanation': string;
	'viagraForm.poppers': string;
	'viagraForm.poppersExplanation': string;
	'viagraForm.adempas': string;
	'viagraForm.adempasExplanation': string;
	'viagraForm.ritonavir': string;
	'viagraForm.ritonavirExplanation': string;
	'viagraForm.opticDamage': string;
	'viagraForm.opticDamageExplanation': string;
	'viagraForm.guidance': string;
	'viagraForm.guidanceSubText': string;
	'viagraForm.addToCart': string;
	'viagraForm.continue': string;
	'viagraForm.contactWithDoctor': string;
	'viagraForm.answerAllQuestions': string;
	'viagraForm.required': string;
	'viagraForm.explanation': string;
	'viagraForm.checkbox': string;
	'viagraForm.zenDeskUnavailable': string;
	'duraphatForm.header': string;
	'duraphatForm.close': string;
	'duraphatForm.ageConsent': string;
	'duraphatForm.cavities': string;
	'duraphatForm.visibleRoots': string;
	'duraphatForm.hygieneDifficulties': string;
	'duraphatForm.dryMouth': string;
	'duraphatForm.importantInformation': string;
	'duraphatForm.orSee': string;
	'duraphatForm.QA': string;
	'duraphatForm.contact': string;
	'duraphatForm.buy': string;
	'duraphatForm.confirm': string;
	'email.subject.RegistrationMessage': string;
	'email.subject.ResetPasswordRequestedMessage': string;
	'email.subject.SetPasswordOnFirstLoginMessage': string;
	'email.subject.ResetPasswordOnLockoutMessage': string;
	'email.subject.OrderCancelledMessage': string;
	'email.subject.OrderLineCancelledMessage': string;
	'email.subject.OrderPlacedConfirmationMessage': string;
	'email.subject.SalesInvoiceCreated': string;
	'email.subject.PackageSentMessage': string;
	'email.subject.ReturnOrderCreatedMessage': string;
	'email.subject.OrderDetailsMessage': string;
	'email.otherPayment': string;
	'email.unknownDeliveryMode': string;
	'errorPage.error': string;
	'errorPage.backToHome': string;
	'errorPage.code400.heading': string;
	'errorPage.code401.heading': string;
	'errorPage.code402.heading': string;
	'errorPage.code403.heading': string;
	'errorPage.code403.description': string;
	'errorPage.code404.heading': string;
	'errorPage.code404.description': string;
	'errorPage.code405.heading': string;
	'errorPage.code406.heading': string;
	'errorPage.code407.heading': string;
	'errorPage.code408.heading': string;
	'errorPage.code410.heading': string;
	'errorPage.code411.heading': string;
	'errorPage.code501.heading': string;
	'errorPage.code502.heading': string;
	'errorPage.code503.heading': string;
	'errorPage.code504.heading': string;
	'errorPage.code505.heading': string;
	'userProfile.name': string;
	'userProfile.welcome': string;
	'userProfile.loggedIn': string;
	'userProfile.logOut': string;
	'userProfile.contactCustomerService': string;
	'userProfile.customerService': string;
	'userProfile.edit': string;
	'userProfile.confirm': string;
	'userProfile.cancel': string;
	'userProfile.changePassword.myPassword': string;
	'userProfile.changePassword.CurrentPassword': string;
	'userProfile.changePassword.NewPassword': string;
	'userProfile.changePassword.ConfirmPassword': string;
	'userProfile.changePassword.successful': string;
	'userProfile.changePassword.errors.fieldRequired': string;
	'userProfile.changePassword.errors.passwordsNotMatch': string;
	'userProfile.cookies.title': string;
	'userProfile.cookies.necessary': string;
	'userProfile.cookies.preferences': string;
	'userProfile.cookies.statistics': string;
	'userProfile.cookies.marketing': string;
	'userProfile.userInformation.heading': string;
	'userProfile.userInformation.firstName': string;
	'userProfile.userInformation.lastName': string;
	'userProfile.userInformation.email': string;
	'userProfile.userInformation.phone': string;
	'userProfile.userInformation.errors.fieldRequired': string;
	'userProfile.userInformation.errors.email': string;
	'userProfile.userInformation.errors.phone': string;
	'userProfile.userInformation.errors.firstNameToLong': string;
	'userProfile.userInformation.errors.lastNameToLong': string;
	'userProfile.userInformation.errors.firstNameWrongCharacters': string;
	'userProfile.userInformation.errors.lastNameWrongCharacters': string;
	'userProfile.userInformation.errors.incorrectValue': string;
	'userProfile.marketingConsents.heading': string;
	'userProfile.marketingConsents.discounts': string;
	'userProfile.marketingConsents.SMS': string;
	'userProfile.marketingConsents.email': string;
	'userProfile.marketingConsents.newsletter': string;
	'userProfile.marketingConsents.reviews': string;
	'userProfile.marketingConsents.abandonedCarts': string;
	'userProfile.marketingConsents.errors.serviceUnavailable': string;
	'userProfile.marketingConsents.errors.updateFailed': string;
	'userProfile.addresses.myAddresses': string;
	'userProfile.addresses.addNewAddress': string;
	'userProfile.orderHistory.emptyTitle': string;
	'userProfile.orderHistory.emptySubtitle1': string;
	'userProfile.orderHistory.emptySubtitle2': string;
	'userProfile.orderHistory.emptyButton': string;
	'userProfile.orderHistory.noConnectionTitle': string;
	'userProfile.orderHistory.noConnectionSubtitle1': string;
	'userProfile.orderHistory.noConnectionSubtitle2': string;
	'userProfile.orderHistory.orderNumber': string;
	'userProfile.orderHistory.orderDate': string;
	'userProfile.orderHistory.package': string;
	'userProfile.orderHistory.of': string;
	'userProfile.orderHistory.send': string;
	'userProfile.orderHistory.packageTracking': string;
	'userProfile.orderHistory.statusText': string;
	'userProfile.orderHistory.cannotFindOrder': string;
	'userProfile.orderHistory.prescriptionHistory': string;
	'userProfile.orderHistory.quantity': string;
	'userProfile.orderHistory.paging.firstPage': string;
	'userProfile.orderHistory.paging.previousPage': string;
	'userProfile.orderHistory.paging.nextPage': string;
	'userProfile.orderHistory.orderStatus.processing': string;
	'userProfile.orderHistory.orderStatus.unknown': string;
	'userProfile.orderHistory.orderStatus.created': string;
	'userProfile.orderHistory.orderStatus.backorder': string;
	'userProfile.orderHistory.orderStatus.delivered': string;
	'userProfile.orderHistory.orderStatus.invoiced': string;
	'userProfile.orderHistory.orderStatus.confirmed': string;
	'userProfile.orderHistory.orderStatus.sent': string;
	'userProfile.orderHistory.orderStatus.lost': string;
	'userProfile.orderHistory.orderStatus.canceled': string;
	'userProfile.orderHistory.orderStatus.return': string;
	'userProfile.orderHistory.orderLineStatus.processing': string;
	'userProfile.orderHistory.orderLineStatus.unknown': string;
	'userProfile.orderHistory.orderLineStatus.created': string;
	'userProfile.orderHistory.orderLineStatus.backorder': string;
	'userProfile.orderHistory.orderLineStatus.delivered': string;
	'userProfile.orderHistory.orderLineStatus.invoiced': string;
	'userProfile.orderHistory.orderLineStatus.confirmed': string;
	'userProfile.orderHistory.orderLineStatus.sent': string;
	'userProfile.orderHistory.orderLineStatus.lost': string;
	'userProfile.orderHistory.orderLineStatus.canceled': string;
	'userProfile.orderHistory.orderLineStatus.return': string;
	'userProfile.orderHistory.orderLineType.cancellation': string;
	'userProfile.orderHistory.orderLineType.refund': string;
	'userProfile.orderHistory.orderLineType.priceAdjustment': string;
	'form.successMessage': string;
	'form.errors.required': string;
	'form.errors.minLength': string;
	'form.errors.maxLength': string;
	'form.errors.sameValueAs': string;
	'form.errors.badRequest': string;
	'form.errors.email': string;
	'form.buttons.confirm': string;
	'form.buttons.cancel': string;
	'form.show': string;
	'form.requiredFields': string;
	'cheapestForFreeDiscount.for': string;
	'productDiscount.upTo': string;
	'contentName.checkout': string;
	'contentName.search': string;
	'contentName.home': string;
	'contentName.error': string;
	'contentName.newsletter.unsubscribe': string;
	'enum.infoBanner.none': string;
	'enum.infoBanner.newItem': string;
	'enum.infoBanner.vegan': string;
	'enum.infoBanner.bestseller': string;
	'enum.infoBanner.lowPrice1': string;
	'enum.infoBanner.lowPrice2': string;
	'enum.infoBanner.goodPurchase1': string;
	'enum.infoBanner.goodPurchase2': string;
	'enum.ProductListVariant.GridWithSwiper': string;
	'enum.ProductListVariant.Horizontal': string;
	'enum.ProductListVariant.GridWithoutSwiper': string;
	'enum.ProductListVariant.None': string;
	'enum.ProductListVariant.CartHorizontal': string;
	'enum.BannerBackgroundVariant.Pink': string;
	'enum.BannerBackgroundVariant.PinkWithRedBorderInside': string;
	'enum.BannerBackgroundVariant.PinkWithBlackBorderInside': string;
	'enum.BannerBackgroundVariant.Blue': string;
	'enum.BannerBackgroundVariant.BlueWithBlackBorderInside': string;
	'enum.BannerBackgroundVariant.WhiteWithRedBorder': string;
	'enum.textBannerBackgroundVariant.Pink': string;
	'enum.textBannerBackgroundVariant.Blue': string;
	'enum.textBannerBackgroundVariant.Red': string;
	'enum.textBannerBackgroundVariant.Black': string;
	'enum.textColor.black': string;
	'enum.textColor.white': string;
	'enum.linkListColumnVariant.twoColumns': string;
	'enum.linkListColumnVariant.fourColumns': string;
	'enum.linkListBackgroundVariant.Grey': string;
	'enum.linkListBackgroundVariant.Pink': string;
	'enum.linkListBackgroundVariant.Blue': string;
	'enum.textHeroBackgroundVariant.Pink': string;
	'enum.textHeroBackgroundVariant.pinkWithRedBorderInside': string;
	'enum.textHeroBackgroundVariant.Black': string;
	'enum.IdentityErrorCode.DefaultError': string;
	'enum.IdentityErrorCode.PasswordMismatch': string;
	'enum.IdentityErrorCode.PasswordTooShort': string;
	'enum.IdentityErrorCode.PasswordRequiresDigit': string;
	'enum.IdentityErrorCode.PasswordRequiresLower': string;
	'enum.IdentityErrorCode.PasswordRequiresUpper': string;
	'enum.ImageSize.Size1920x240': string;
	'enum.ImageSize.Size1920x400': string;
	'enum.ImageSize.Size1260x400': string;
	'newsletter.AddedToRecipientList': string;
	'newsletter.RemovedFromUnsubscribedList': string;
	'newsletter.RecipientIsEitherBlacklistedOrExceededBounceLimit': string;
	'newsletter.AlreadySubscribed': string;
	'newsletter.ServerError': string;
	'newsletter.subscriptionConfirmed': string;
	'newsletter.backToMainPage': string;
	'newsletter.SignUpAgain': string;
	'newsletter.UnsubscribeReasonNotSelected': string;
	'newsletter.send': string;
	'newsletter.EmailPlaceholder': string;
	'newsletter.SignUp': string;
	'newsletter.LackOfConsent': string;
	'newsletter.InvalidEmail': string;
	'newsletter.UnexpectedError': string;
	'newsletter.UnknownError': string;
	'newsletter.DidYouMean': string;
	'newsletter.AreYouSure': string;
	'productNotifications.title': string;
	'productNotifications.subtitle': string;
	'emailSuggestion.header': string;
	'emailSuggestion.incorrectAddress': string;
	'emailSuggestion.didYouMeanToUse': string;
	'emailSuggestion.withSuggestionRejectButton': string;
	'emailSuggestion.withoutSuggestionRejectButton': string;
	'emailSuggestion.withSuggestionAcceptButton': string;
	'emailSuggestion.withoutSuggestionAcceptButton': string;
	'emailSuggestion.areYouSure': string;
	'powerReviews.writeAReview': string;
	'powerReviews.reviewYourPurchase': string;
	'klarna.orderNumber': string;
	'klarna.refund': string;
	'klarna.invoiceId': string;
	'klarna.shipment': string;
	'klarna.rxLineItemName': string;
	'klarna.otcLineItemName': string;
	'klarna.tgLineItemName': string;
	'errorMessageBar.close': string;
	'errorMessageBar.defaultMessage': string;
	'bankId.yourSecureSession': string;
	'prescriptionHistory.downloadPrescriptionHistory': string;
}
export var keys: ITranslations = {
	'en': 'en',
	'header.searchPlaceholder': 'header.searchPlaceholder',
	'header.products': 'header.products',
	'header.search': 'header.search',
	'header.clearSearch': 'header.clearSearch',
	'header.physicalStoreMode': 'header.physicalStoreMode',
	'header.cartFromDifferentWarehouse': 'header.cartFromDifferentWarehouse',
	'header.searchLabel': 'header.searchLabel',
	'footer.followUs': 'footer.followUs',
	'footer.seeCookieConsent': 'footer.seeCookieConsent',
	'actionMenu.myPage': 'actionMenu.myPage',
	'actionMenu.myOrders': 'actionMenu.myOrders',
	'actionMenu.myFavourites': 'actionMenu.myFavourites',
	'actionMenu.prescriptionHistory': 'actionMenu.prescriptionHistory',
	'actionMenu.logIn': 'actionMenu.logIn',
	'actionMenu.register': 'actionMenu.register',
	'actionMenu.logOut': 'actionMenu.logOut',
	'actionMenu.activeBankIdSession': 'actionMenu.activeBankIdSession',
	'actionMenu.logOutFromBankId': 'actionMenu.logOutFromBankId',
	'actionMenu.customerService': 'actionMenu.customerService',
	'actionMenu.rxService': 'actionMenu.rxService',
	'homePage.title': 'homePage.title',
	'common.tryAgainOrContactCustomerSupport': 'common.tryAgainOrContactCustomerSupport',
	'navigation.menu': 'navigation.menu',
	'navigation.rxMenu': 'navigation.rxMenu',
	'navigation.myPage': 'navigation.myPage',
	'navigation.cart': 'navigation.cart',
	'navigation.favourites': 'navigation.favourites',
	'navigation.categories': 'navigation.categories',
	'navigation.categoriesAndProducts': 'navigation.categoriesAndProducts',
	'navigation.shortcuts': 'navigation.shortcuts',
	'navigation.buyPrescription': 'navigation.buyPrescription',
	'navigation.chatWithPharmacist': 'navigation.chatWithPharmacist',
	'navigation.logIn': 'navigation.logIn',
	'navigation.logOut': 'navigation.logOut',
	'navigation.hi': 'navigation.hi',
	'navigation.registrationLink': 'navigation.registrationLink',
	'navigation.open': 'navigation.open',
	'navigation.close': 'navigation.close',
	'navigation.back': 'navigation.back',
	'navigation.seeAllProducts': 'navigation.seeAllProducts',
	'navigation.physicalStoreMode': 'navigation.physicalStoreMode',
	'navigation.skipToContent': 'navigation.skipToContent',
	'navigation.goToCheckout': 'navigation.goToCheckout',
	'navigation.search': 'navigation.search',
	'favourites.removed': 'favourites.removed',
	'favourites.login': 'favourites.login',
	'favourites.register': 'favourites.register',
	'favourites.loginRequiredHeader': 'favourites.loginRequiredHeader',
	'favourites.loginRequiredContent': 'favourites.loginRequiredContent',
	'favourites.saveItems': 'favourites.saveItems',
	'favourites.description': 'favourites.description',
	'favourites.seeAllProducts': 'favourites.seeAllProducts',
	'favourites.productRemoved': 'favourites.productRemoved',
	'favourites.added': 'favourites.added',
	'favourites.firstFavouriteHeading': 'favourites.firstFavouriteHeading',
	'favourites.firstFavouriteContent': 'favourites.firstFavouriteContent',
	'favourites.goToFavourites': 'favourites.goToFavourites',
	'favourites.addToFavourites': 'favourites.addToFavourites',
	'favourites.removeFromFavourites': 'favourites.removeFromFavourites',
	'newMessage.heading': 'newMessage.heading',
	'newMessage.content': 'newMessage.content',
	'newMessage.link': 'newMessage.link',
	'expectedDeliveryDate.estimatedDeliveryTo': 'expectedDeliveryDate.estimatedDeliveryTo',
	'expectedDeliveryDate.deliveryDate': 'expectedDeliveryDate.deliveryDate',
	'expectedDeliveryDate.deliveryTo': 'expectedDeliveryDate.deliveryTo',
	'expectedDeliveryDate.delivery': 'expectedDeliveryDate.delivery',
	'expectedDeliveryDate.deliveryToInfo': 'expectedDeliveryDate.deliveryToInfo',
	'expectedDeliveryDate.change': 'expectedDeliveryDate.change',
	'expectedDeliveryDate.info': 'expectedDeliveryDate.info',
	'expectedDeliveryDate.postalCode': 'expectedDeliveryDate.postalCode',
	'expectedDeliveryDate.checkDeliveryDate': 'expectedDeliveryDate.checkDeliveryDate',
	'expectedDeliveryDate.check': 'expectedDeliveryDate.check',
	'expectedDeliveryDate.preferredMethod': 'expectedDeliveryDate.preferredMethod',
	'expectedDeliveryDate.fastestMethod': 'expectedDeliveryDate.fastestMethod',
	'expectedDeliveryDate.allMethods': 'expectedDeliveryDate.allMethods',
	'expectedDeliveryDate.failPostalCode': 'expectedDeliveryDate.failPostalCode',
	'expectedDeliveryDate.seeMore': 'expectedDeliveryDate.seeMore',
	'expectedDeliveryDate.notAvailable': 'expectedDeliveryDate.notAvailable',
	'expectedDeliveryDate.aboutDeliveryMethods': 'expectedDeliveryDate.aboutDeliveryMethods',
	'expectedDeliveryDate.noMethods.title': 'expectedDeliveryDate.noMethods.title',
	'expectedDeliveryDate.noMethods.subtitle': 'expectedDeliveryDate.noMethods.subtitle',
	'expectedDeliveryDate.unexpectedError.title': 'expectedDeliveryDate.unexpectedError.title',
	'expectedDeliveryDate.unexpectedError.subtitle': 'expectedDeliveryDate.unexpectedError.subtitle',
	'expectedDeliveryDate.today': 'expectedDeliveryDate.today',
	'expectedDeliveryDate.tomorrow': 'expectedDeliveryDate.tomorrow',
	'brand.favourite': 'brand.favourite',
	'brand.popular': 'brand.popular',
	'brand.brands': 'brand.brands',
	'cartSummary.addedToCart': 'cartSummary.addedToCart',
	'cartSummary.itemsInYourCart': 'cartSummary.itemsInYourCart',
	'cartSummary.cart': 'cartSummary.cart',
	'cartSummary.prescription': 'cartSummary.prescription',
	'cartSummary.closeCart': 'cartSummary.closeCart',
	'cartSummary.openCart': 'cartSummary.openCart',
	'cartSummary.product': 'cartSummary.product',
	'cartSummary.products': 'cartSummary.products',
	'cartSummary.freeShipping': 'cartSummary.freeShipping',
	'cartSummary.totalSum': 'cartSummary.totalSum',
	'cartSummary.spared': 'cartSummary.spared',
	'cartSummary.goToCart': 'cartSummary.goToCart',
	'cartSummary.goToCheckout': 'cartSummary.goToCheckout',
	'cartSummary.loginTitle': 'cartSummary.loginTitle',
	'cartSummary.loginSubtitle': 'cartSummary.loginSubtitle',
	'cartSummary.loginButton': 'cartSummary.loginButton',
	'cartSummary.registerTitle': 'cartSummary.registerTitle',
	'cartSummary.registerSubtitle': 'cartSummary.registerSubtitle',
	'cartSummary.registerButton': 'cartSummary.registerButton',
	'cartSummary.vippsTitle': 'cartSummary.vippsTitle',
	'cartSummary.vippsSubtitle': 'cartSummary.vippsSubtitle',
	'cartSummary.vippsButton': 'cartSummary.vippsButton',
	'cartSummary.emptyCartHeading': 'cartSummary.emptyCartHeading',
	'cartSummary.emptyCartMessage': 'cartSummary.emptyCartMessage',
	'cartSummary.includingTaxes': 'cartSummary.includingTaxes',
	'cartSummary.remove': 'cartSummary.remove',
	'cartSummary.addToCartMessage': 'cartSummary.addToCartMessage',
	'cartSummary.discount': 'cartSummary.discount',
	'cartSummary.delivery': 'cartSummary.delivery',
	'cartSummary.free': 'cartSummary.free',
	'cartSummary.from': 'cartSummary.from',
	'cartSummary.freeDeliveryNeededAmount': 'cartSummary.freeDeliveryNeededAmount',
	'cartSummary.freeDeliveryGratis': 'cartSummary.freeDeliveryGratis',
	'cartSummary.freeDeliveryAchieved': 'cartSummary.freeDeliveryAchieved',
	'cartSummary.freeDeliveryCalculationHeading': 'cartSummary.freeDeliveryCalculationHeading',
	'cartSummary.freeDeliveryButtonA11yText': 'cartSummary.freeDeliveryButtonA11yText',
	'cartSummary.freeDeliveryButtonHide': 'cartSummary.freeDeliveryButtonHide',
	'cartSummary.freeDeliveryButtonShow': 'cartSummary.freeDeliveryButtonShow',
	'cartSummary.completePurchase': 'cartSummary.completePurchase',
	'cartSummary.completePurchaseForFreeDelivery': 'cartSummary.completePurchaseForFreeDelivery',
	'cartSummary.merged': 'cartSummary.merged',
	'cartSummary.increaseQuantity': 'cartSummary.increaseQuantity',
	'cartSummary.decreaseQuantity': 'cartSummary.decreaseQuantity',
	'cartSummary.validation.Unexpected': 'cartSummary.validation.Unexpected',
	'cartSummary.validation.CannotProcessDueToMissingOrderStatus': 'cartSummary.validation.CannotProcessDueToMissingOrderStatus',
	'cartSummary.validation.RemovedDueToCodeMissing': 'cartSummary.validation.RemovedDueToCodeMissing',
	'cartSummary.validation.RemovedDueToNotAvailableInMarket': 'cartSummary.validation.RemovedDueToNotAvailableInMarket',
	'cartSummary.validation.RemovedDueToUnavailableCatalog': 'cartSummary.validation.RemovedDueToUnavailableCatalog',
	'cartSummary.validation.RemovedDueToUnavailableItem': 'cartSummary.validation.RemovedDueToUnavailableItem',
	'cartSummary.validation.RemovedDueToInsufficientQuantityInInventory': 'cartSummary.validation.RemovedDueToInsufficientQuantityInInventory',
	'cartSummary.validation.RemovedDueToInactiveWarehouse': 'cartSummary.validation.RemovedDueToInactiveWarehouse',
	'cartSummary.validation.RemovedDueToMissingInventoryInformation': 'cartSummary.validation.RemovedDueToMissingInventoryInformation',
	'cartSummary.validation.RemovedDueToInvalidPrice': 'cartSummary.validation.RemovedDueToInvalidPrice',
	'cartSummary.validation.RemovedDueToInvalidMaxQuantitySetting': 'cartSummary.validation.RemovedDueToInvalidMaxQuantitySetting',
	'cartSummary.validation.AdjustedQuantityByMinQuantity': 'cartSummary.validation.AdjustedQuantityByMinQuantity',
	'cartSummary.validation.AdjustedQuantityByMaxQuantity': 'cartSummary.validation.AdjustedQuantityByMaxQuantity',
	'cartSummary.validation.AdjustedQuantityByBackorderQuantity': 'cartSummary.validation.AdjustedQuantityByBackorderQuantity',
	'cartSummary.validation.AdjustedQuantityByPreorderQuantity': 'cartSummary.validation.AdjustedQuantityByPreorderQuantity',
	'cartSummary.validation.AdjustedQuantityByAvailableQuantity': 'cartSummary.validation.AdjustedQuantityByAvailableQuantity',
	'cartSummary.validation.PlacedPricedChanged': 'cartSummary.validation.PlacedPricedChanged',
	'cartSummary.validation.RemovedGiftDueToInsufficientQuantityInInventory': 'cartSummary.validation.RemovedGiftDueToInsufficientQuantityInInventory',
	'cartSummary.validation.RejectedInventoryRequestDueToInsufficientQuantity': 'cartSummary.validation.RejectedInventoryRequestDueToInsufficientQuantity',
	'cartSummary.validation.AdjustedQuantityByOtcLimitQuantity': 'cartSummary.validation.AdjustedQuantityByOtcLimitQuantity',
	'cartSummary.validation.CannotBeAddedDueToDateTimeRestrictions': 'cartSummary.validation.CannotBeAddedDueToDateTimeRestrictions',
	'cartSummary.validation.CannotBeRemovedDueToPriceRecalculationError': 'cartSummary.validation.CannotBeRemovedDueToPriceRecalculationError',
	'cartSummary.validation.CannotBeAddedDueToCooledProductsDisabled': 'cartSummary.validation.CannotBeAddedDueToCooledProductsDisabled',
	'cartSummary.validation.CannotBeAddedDueToCooledProductsConflict': 'cartSummary.validation.CannotBeAddedDueToCooledProductsConflict',
	'cartSummary.validation.addToCart.unexpectedError': 'cartSummary.validation.addToCart.unexpectedError',
	'cartSummary.validation.invalidActionPleaseRefresh': 'cartSummary.validation.invalidActionPleaseRefresh',
	'cartSummary.validation.DifferentWarehouse': 'cartSummary.validation.DifferentWarehouse',
	'cartSummary.validation.atLeastOneUnavailable': 'cartSummary.validation.atLeastOneUnavailable',
	'cartSummary.validation.quantityUnavailable': 'cartSummary.validation.quantityUnavailable',
	'cartSummary.validation.confirmAvailableQuantity': 'cartSummary.validation.confirmAvailableQuantity',
	'cartSummary.validation.onlyAvailable': 'cartSummary.validation.onlyAvailable',
	'cartWidget.closeInfo': 'cartWidget.closeInfo',
	'vippsExpress.heading': 'vippsExpress.heading',
	'vippsExpress.subheading1': 'vippsExpress.subheading1',
	'vippsExpress.subheading2': 'vippsExpress.subheading2',
	'vippsExpress.phoneNumber': 'vippsExpress.phoneNumber',
	'vippsExpress.ssn': 'vippsExpress.ssn',
	'vippsExpress.invalidSsn': 'vippsExpress.invalidSsn',
	'vippsExpress.button': 'vippsExpress.button',
	'modal.ok': 'modal.ok',
	'modal.confirm': 'modal.confirm',
	'modal.cancel': 'modal.cancel',
	'modal.close': 'modal.close',
	'modal.sessionExpired.title': 'modal.sessionExpired.title',
	'modal.sessionExpired.message': 'modal.sessionExpired.message',
	'modal.errorInfo': 'modal.errorInfo',
	'modal.goBack': 'modal.goBack',
	'modal.refresh': 'modal.refresh',
	'modal.rxSession.goToCheckout': 'modal.rxSession.goToCheckout',
	'modal.rxSession.close': 'modal.rxSession.close',
	'modal.rxSession.logIn': 'modal.rxSession.logIn',
	'modal.rxSession.logout': 'modal.rxSession.logout',
	'modal.rxSession.goToCart': 'modal.rxSession.goToCart',
	'modal.rxSession.expiringHeading': 'modal.rxSession.expiringHeading',
	'modal.rxSession.expiredHeading': 'modal.rxSession.expiredHeading',
	'modal.rxSession.logoutHeading': 'modal.rxSession.logoutHeading',
	'modal.rxSession.minute': 'modal.rxSession.minute',
	'modal.rxSession.minutes': 'modal.rxSession.minutes',
	'modal.rxSession.expiringBody': 'modal.rxSession.expiringBody',
	'modal.rxSession.expiredBody': 'modal.rxSession.expiredBody',
	'modal.rxSession.logoutBody': 'modal.rxSession.logoutBody',
	'modal.cooledProducts.heading': 'modal.cooledProducts.heading',
	'modal.cooledProducts.descriptionCooled': 'modal.cooledProducts.descriptionCooled',
	'modal.cooledProducts.descriptionWarm': 'modal.cooledProducts.descriptionWarm',
	'modal.cooledProducts.selectProducts': 'modal.cooledProducts.selectProducts',
	'modal.cooledProducts.singleConflictedCooledProduct': 'modal.cooledProducts.singleConflictedCooledProduct',
	'modal.cooledProducts.singleConflictedWarmProduct': 'modal.cooledProducts.singleConflictedWarmProduct',
	'modal.cooledProducts.multipleConflictedCooledProducts': 'modal.cooledProducts.multipleConflictedCooledProducts',
	'modal.cooledProducts.multipleConflictedWarmProducts': 'modal.cooledProducts.multipleConflictedWarmProducts',
	'modal.cooledProducts.selectCooledProduct': 'modal.cooledProducts.selectCooledProduct',
	'modal.cooledProducts.selectWarmProduct': 'modal.cooledProducts.selectWarmProduct',
	'modal.cooledProducts.cooledProductBadge': 'modal.cooledProducts.cooledProductBadge',
	'modal.cooledProducts.keep': 'modal.cooledProducts.keep',
	'modal.cooledProducts.errors.nothingSelected': 'modal.cooledProducts.errors.nothingSelected',
	'payment.title': 'payment.title',
	'payment.addPayment': 'payment.addPayment',
	'payment.paymentMethods': 'payment.paymentMethods',
	'payment.paymentAddress': 'payment.paymentAddress',
	'payment.addToAddressBook': 'payment.addToAddressBook',
	'payment.submit': 'payment.submit',
	'payment.payWithVipps': 'payment.payWithVipps',
	'payment.processing': 'payment.processing',
	'payment.pleaseWait': 'payment.pleaseWait',
	'payment.payWith': 'payment.payWith',
	'payment.klarnaErrorMessage': 'payment.klarnaErrorMessage',
	'payment.vippsExpressCheckout': 'payment.vippsExpressCheckout',
	'checkout.name': 'checkout.name',
	'checkout.heading': 'checkout.heading',
	'checkout.required': 'checkout.required',
	'checkout.incorrectPostalCode': 'checkout.incorrectPostalCode',
	'checkout.incorrectEmail': 'checkout.incorrectEmail',
	'checkout.incorrectPhone': 'checkout.incorrectPhone',
	'checkout.incorrectPostalCodeOrCity': 'checkout.incorrectPostalCodeOrCity',
	'checkout.incorrectCity': 'checkout.incorrectCity',
	'checkout.orderHasChangedHeading': 'checkout.orderHasChangedHeading',
	'checkout.orderHasChangedContent': 'checkout.orderHasChangedContent',
	'checkout.deliveryMethodHasChangedHeading': 'checkout.deliveryMethodHasChangedHeading',
	'checkout.deliveryMethodHasChangedContent': 'checkout.deliveryMethodHasChangedContent',
	'checkout.ok': 'checkout.ok',
	'checkout.consentsRequired': 'checkout.consentsRequired',
	'checkout.termsOfSaleConsent.ingress': 'checkout.termsOfSaleConsent.ingress',
	'checkout.termsOfSaleConsent.link': 'checkout.termsOfSaleConsent.link',
	'checkout.continueShopping': 'checkout.continueShopping',
	'checkout.backToCart': 'checkout.backToCart',
	'checkout.paymentSuccess': 'checkout.paymentSuccess',
	'checkout.summary.title': 'checkout.summary.title',
	'checkout.summary.productsInCart': 'checkout.summary.productsInCart',
	'checkout.summary.sum': 'checkout.summary.sum',
	'checkout.summary.freeDelivery': 'checkout.summary.freeDelivery',
	'checkout.summary.goToAddresses': 'checkout.summary.goToAddresses',
	'checkout.summary.goToDelivery': 'checkout.summary.goToDelivery',
	'checkout.summary.warningTop': 'checkout.summary.warningTop',
	'checkout.summary.warningBottom': 'checkout.summary.warningBottom',
	'checkout.summary.discountCode': 'checkout.summary.discountCode',
	'checkout.summary.enterDiscountCode': 'checkout.summary.enterDiscountCode',
	'checkout.summary.addCode': 'checkout.summary.addCode',
	'checkout.summary.discount': 'checkout.summary.discount',
	'checkout.summary.delivery': 'checkout.summary.delivery',
	'checkout.summary.total': 'checkout.summary.total',
	'checkout.summary.includeTax': 'checkout.summary.includeTax',
	'checkout.summary.apologyTechnicalError': 'checkout.summary.apologyTechnicalError',
	'checkout.summary.add': 'checkout.summary.add',
	'checkout.summary.reviewCart': 'checkout.summary.reviewCart',
	'checkout.summary.orderOverview': 'checkout.summary.orderOverview',
	'checkout.summary.coupons.genericCouponError': 'checkout.summary.coupons.genericCouponError',
	'checkout.summary.coupons.anonymousCustomerRedemptionError': 'checkout.summary.coupons.anonymousCustomerRedemptionError',
	'checkout.summary.coupons.alreadyUsedError': 'checkout.summary.coupons.alreadyUsedError',
	'checkout.summary.coupons.couponEmpty': 'checkout.summary.coupons.couponEmpty',
	'checkout.summary.coupons.couponTechnicalError': 'checkout.summary.coupons.couponTechnicalError',
	'checkout.summary.coupons.couponWithoutDiscount': 'checkout.summary.coupons.couponWithoutDiscount',
	'checkout.summary.coupons.requireRxInCart': 'checkout.summary.coupons.requireRxInCart',
	'checkout.summary.coupons.notFoundForUser': 'checkout.summary.coupons.notFoundForUser',
	'checkout.summary.coupons.notActiveYet': 'checkout.summary.coupons.notActiveYet',
	'checkout.summary.coupons.expired': 'checkout.summary.coupons.expired',
	'checkout.summary.coupons.removeCoupon': 'checkout.summary.coupons.removeCoupon',
	'checkout.ageConfirmation.InvalidNumber': 'checkout.ageConfirmation.InvalidNumber',
	'checkout.ageConfirmation.Invalid': 'checkout.ageConfirmation.Invalid',
	'checkout.ageConfirmation.InvalidAge': 'checkout.ageConfirmation.InvalidAge',
	'checkout.ageConfirmation.header': 'checkout.ageConfirmation.header',
	'checkout.ageConfirmation.info': 'checkout.ageConfirmation.info',
	'checkout.ageConfirmation.input': 'checkout.ageConfirmation.input',
	'checkout.ageConfirmation.button': 'checkout.ageConfirmation.button',
	'checkout.delivery.address': 'checkout.delivery.address',
	'checkout.delivery.sendTo': 'checkout.delivery.sendTo',
	'checkout.delivery.addAnotherAddress': 'checkout.delivery.addAnotherAddress',
	'checkout.delivery.method': 'checkout.delivery.method',
	'checkout.delivery.hasMedicines': 'checkout.delivery.hasMedicines',
	'checkout.delivery.notAvailableMethod': 'checkout.delivery.notAvailableMethod',
	'checkout.delivery.readAboutCooledDelivery': 'checkout.delivery.readAboutCooledDelivery',
	'checkout.delivery.cooledDeliveryNotAvailable': 'checkout.delivery.cooledDeliveryNotAvailable',
	'checkout.delivery.removeFromCart': 'checkout.delivery.removeFromCart',
	'checkout.delivery.goToPayment': 'checkout.delivery.goToPayment',
	'checkout.delivery.placeOrder': 'checkout.delivery.placeOrder',
	'checkout.delivery.delete': 'checkout.delivery.delete',
	'checkout.delivery.edit': 'checkout.delivery.edit',
	'checkout.delivery.formAddress': 'checkout.delivery.formAddress',
	'checkout.delivery.postalCodeAndCity': 'checkout.delivery.postalCodeAndCity',
	'checkout.delivery.postalCodeAndCityPlaceholder': 'checkout.delivery.postalCodeAndCityPlaceholder',
	'checkout.delivery.companyName': 'checkout.delivery.companyName',
	'checkout.delivery.email': 'checkout.delivery.email',
	'checkout.delivery.phoneNumber': 'checkout.delivery.phoneNumber',
	'checkout.delivery.checkPhoneNumber': 'checkout.delivery.checkPhoneNumber',
	'checkout.delivery.firstName': 'checkout.delivery.firstName',
	'checkout.delivery.lastName': 'checkout.delivery.lastName',
	'checkout.delivery.city': 'checkout.delivery.city',
	'checkout.delivery.formAdd': 'checkout.delivery.formAdd',
	'checkout.delivery.noOpeningHours': 'checkout.delivery.noOpeningHours',
	'checkout.delivery.openingHours': 'checkout.delivery.openingHours',
	'checkout.delivery.formCancel': 'checkout.delivery.formCancel',
	'checkout.delivery.formHeading': 'checkout.delivery.formHeading',
	'checkout.delivery.formConfirm': 'checkout.delivery.formConfirm',
	'checkout.delivery.toThisAddress': 'checkout.delivery.toThisAddress',
	'checkout.delivery.confirmAddressDelete': 'checkout.delivery.confirmAddressDelete',
	'checkout.delivery.acceptBamboraPayments': 'checkout.delivery.acceptBamboraPayments',
	'checkout.delivery.postalCode': 'checkout.delivery.postalCode',
	'checkout.delivery.search': 'checkout.delivery.search',
	'checkout.delivery.invalidPostalCode': 'checkout.delivery.invalidPostalCode',
	'checkout.delivery.chooseAnotherLocation': 'checkout.delivery.chooseAnotherLocation',
	'checkout.delivery.chooseAnotherDate': 'checkout.delivery.chooseAnotherDate',
	'checkout.delivery.selectDeliveryDate': 'checkout.delivery.selectDeliveryDate',
	'checkout.delivery.servicePointNotSelected': 'checkout.delivery.servicePointNotSelected',
	'checkout.delivery.formIsOpen': 'checkout.delivery.formIsOpen',
	'checkout.delivery.addressUnavailable': 'checkout.delivery.addressUnavailable',
	'checkout.delivery.addressHasMissingNumberWarning': 'checkout.delivery.addressHasMissingNumberWarning',
	'checkout.delivery.line1required': 'checkout.delivery.line1required',
	'checkout.delivery.line1MissingNumber': 'checkout.delivery.line1MissingNumber',
	'checkout.delivery.noServicePointsAvailable': 'checkout.delivery.noServicePointsAvailable',
	'checkout.delivery.firstNameWrongCharacters': 'checkout.delivery.firstNameWrongCharacters',
	'checkout.delivery.lastNameWrongCharacters': 'checkout.delivery.lastNameWrongCharacters',
	'checkout.delivery.line1WrongCharacters': 'checkout.delivery.line1WrongCharacters',
	'checkout.delivery.coWrongCharacters': 'checkout.delivery.coWrongCharacters',
	'checkout.delivery.availableOptions': 'checkout.delivery.availableOptions',
	'checkout.delivery.showNotAvailableOptions': 'checkout.delivery.showNotAvailableOptions',
	'checkout.delivery.unavailableHeading': 'checkout.delivery.unavailableHeading',
	'checkout.delivery.unavailableSubheading': 'checkout.delivery.unavailableSubheading',
	'checkout.delivery.newAddress': 'checkout.delivery.newAddress',
	'checkout.delivery.editAddresses': 'checkout.delivery.editAddresses',
	'checkout.delivery.selectAddress': 'checkout.delivery.selectAddress',
	'checkout.delivery.noMethodsAvailableHeading': 'checkout.delivery.noMethodsAvailableHeading',
	'checkout.delivery.noMethodsAvailableLine1': 'checkout.delivery.noMethodsAvailableLine1',
	'checkout.delivery.noMethodsAvailableLine2': 'checkout.delivery.noMethodsAvailableLine2',
	'checkout.delivery.noMethodsAvailableReadMore': 'checkout.delivery.noMethodsAvailableReadMore',
	'checkout.delivery.instaboxEta': 'checkout.delivery.instaboxEta',
	'checkout.delivery.showMore': 'checkout.delivery.showMore',
	'checkout.delivery.pickupPoints.emptyTitle': 'checkout.delivery.pickupPoints.emptyTitle',
	'checkout.delivery.pickupPoints.emptySubtitle': 'checkout.delivery.pickupPoints.emptySubtitle',
	'checkout.delivery.pickupPoints.noConnectionTitle': 'checkout.delivery.pickupPoints.noConnectionTitle',
	'checkout.delivery.pickupPoints.noConnectionSubtitle': 'checkout.delivery.pickupPoints.noConnectionSubtitle',
	'checkout.delivery.days.monday': 'checkout.delivery.days.monday',
	'checkout.delivery.days.tuesday': 'checkout.delivery.days.tuesday',
	'checkout.delivery.days.wednesday': 'checkout.delivery.days.wednesday',
	'checkout.delivery.days.thursday': 'checkout.delivery.days.thursday',
	'checkout.delivery.days.friday': 'checkout.delivery.days.friday',
	'checkout.delivery.days.saturday': 'checkout.delivery.days.saturday',
	'checkout.delivery.days.sunday': 'checkout.delivery.days.sunday',
	'checkout.delivery.daysLong.monday': 'checkout.delivery.daysLong.monday',
	'checkout.delivery.daysLong.tuesday': 'checkout.delivery.daysLong.tuesday',
	'checkout.delivery.daysLong.wednesday': 'checkout.delivery.daysLong.wednesday',
	'checkout.delivery.daysLong.thursday': 'checkout.delivery.daysLong.thursday',
	'checkout.delivery.daysLong.friday': 'checkout.delivery.daysLong.friday',
	'checkout.delivery.daysLong.saturday': 'checkout.delivery.daysLong.saturday',
	'checkout.delivery.daysLong.sunday': 'checkout.delivery.daysLong.sunday',
	'checkout.delivery.today': 'checkout.delivery.today',
	'checkout.delivery.closed': 'checkout.delivery.closed',
	'checkout.delivery.tomorrow': 'checkout.delivery.tomorrow',
	'checkout.shippingMethodAvailability.AddressNotSelected': 'checkout.shippingMethodAvailability.AddressNotSelected',
	'checkout.shippingMethodAvailability.DeliveryMethodNotSelected': 'checkout.shippingMethodAvailability.DeliveryMethodNotSelected',
	'checkout.shippingMethodAvailability.InvalidDimensions': 'checkout.shippingMethodAvailability.InvalidDimensions',
	'checkout.shippingMethodAvailability.MailboxNotEligible': 'checkout.shippingMethodAvailability.MailboxNotEligible',
	'checkout.shippingMethodAvailability.PorterBuddyAddressNotSupported': 'checkout.shippingMethodAvailability.PorterBuddyAddressNotSupported',
	'checkout.shippingMethodAvailability.PorterBuddyNotAvailable': 'checkout.shippingMethodAvailability.PorterBuddyNotAvailable',
	'checkout.shippingMethodAvailability.HeltHjemNotAvailable': 'checkout.shippingMethodAvailability.HeltHjemNotAvailable',
	'checkout.shippingMethodAvailability.PostNHomeNotAvailable': 'checkout.shippingMethodAvailability.PostNHomeNotAvailable',
	'checkout.shippingMethodAvailability.PostNPickNotAvailable': 'checkout.shippingMethodAvailability.PostNPickNotAvailable',
	'checkout.shippingMethodAvailability.PostNPickLockersNotAvailable': 'checkout.shippingMethodAvailability.PostNPickLockersNotAvailable',
	'checkout.shippingMethodAvailability.PorterBuddyWindowNotSelected': 'checkout.shippingMethodAvailability.PorterBuddyWindowNotSelected',
	'checkout.shippingMethodAvailability.PostNordServicePointNotAvailable': 'checkout.shippingMethodAvailability.PostNordServicePointNotAvailable',
	'checkout.shippingMethodAvailability.InstaBoxExpressNotAvailable': 'checkout.shippingMethodAvailability.InstaBoxExpressNotAvailable',
	'checkout.shippingMethodAvailability.InstaBoxHomeNotAvailable': 'checkout.shippingMethodAvailability.InstaBoxHomeNotAvailable',
	'checkout.shippingMethodAvailability.PostNordServicePointNotSelected': 'checkout.shippingMethodAvailability.PostNordServicePointNotSelected',
	'checkout.shippingMethodAvailability.InstaBoxParcelLockerNotSelected': 'checkout.shippingMethodAvailability.InstaBoxParcelLockerNotSelected',
	'checkout.shippingMethodAvailability.GordonTimeWindowNotSelected': 'checkout.shippingMethodAvailability.GordonTimeWindowNotSelected',
	'checkout.shippingMethodAvailability.GordonNotAvailable': 'checkout.shippingMethodAvailability.GordonNotAvailable',
	'checkout.shippingMethodAvailability.NotAvailable': 'checkout.shippingMethodAvailability.NotAvailable',
	'checkout.shippingMethodAvailability.BadTemperatures': 'checkout.shippingMethodAvailability.BadTemperatures',
	'checkout.shippingMethodAvailability.AirmeeHomeNotAvailable': 'checkout.shippingMethodAvailability.AirmeeHomeNotAvailable',
	'checkout.shippingMethodAvailability.AirmeeHomeNotSelected': 'checkout.shippingMethodAvailability.AirmeeHomeNotSelected',
	'checkout.shippingMethodAvailability.OtcNotAvailable': 'checkout.shippingMethodAvailability.OtcNotAvailable',
	'checkout.shippingMethodAvailability.RxNotAvailable': 'checkout.shippingMethodAvailability.RxNotAvailable',
	'checkout.shippingMethodAvailability.HeltHjemServicePointNotAvailable': 'checkout.shippingMethodAvailability.HeltHjemServicePointNotAvailable',
	'checkout.shippingMethodAvailability.HeltHjemServicePointNotSelected': 'checkout.shippingMethodAvailability.HeltHjemServicePointNotSelected',
	'checkout.validation.couldNotSave': 'checkout.validation.couldNotSave',
	'checkout.validation.ValidationFailed': 'checkout.validation.ValidationFailed',
	'checkout.validation.OrderAdjustedAfterValidation': 'checkout.validation.OrderAdjustedAfterValidation',
	'checkout.validation.PriceChangedAfterValidation': 'checkout.validation.PriceChangedAfterValidation',
	'checkout.validation.PriceMismatch': 'checkout.validation.PriceMismatch',
	'checkout.validation.InvalidDeliveryServiceLocation': 'checkout.validation.InvalidDeliveryServiceLocation',
	'checkout.validation.ItemsRemovedAfterInventoryValidation': 'checkout.validation.ItemsRemovedAfterInventoryValidation',
	'checkout.validation.PaymentFailed': 'checkout.validation.PaymentFailed',
	'checkout.validation.MissingDeliveryMethod': 'checkout.validation.MissingDeliveryMethod',
	'checkout.validation.InvalidShippingAddress': 'checkout.validation.InvalidShippingAddress',
	'checkout.validation.UnexpectedError': 'checkout.validation.UnexpectedError',
	'checkout.validation.PaymentCancelled': 'checkout.validation.PaymentCancelled',
	'checkout.validation.IncorrectFirstName': 'checkout.validation.IncorrectFirstName',
	'checkout.validation.IncorrectLastName': 'checkout.validation.IncorrectLastName',
	'checkout.validation.IncorrectPostalCode': 'checkout.validation.IncorrectPostalCode',
	'checkout.validation.IncorrectCity': 'checkout.validation.IncorrectCity',
	'checkout.validation.MissingAddress': 'checkout.validation.MissingAddress',
	'checkout.validation.IncorrectLine1': 'checkout.validation.IncorrectLine1',
	'checkout.validation.NullAddress': 'checkout.validation.NullAddress',
	'checkout.validation.CannotDeleteLastAddress': 'checkout.validation.CannotDeleteLastAddress',
	'checkout.validation.AddressDoesNotExists': 'checkout.validation.AddressDoesNotExists',
	'checkout.validation.AddressAlreadyExists': 'checkout.validation.AddressAlreadyExists',
	'checkout.validation.IncorrectPhoneNumber': 'checkout.validation.IncorrectPhoneNumber',
	'checkout.validation.EmptyPhoneNumber': 'checkout.validation.EmptyPhoneNumber',
	'checkout.validation.IncorrectCompany': 'checkout.validation.IncorrectCompany',
	'checkout.validation.Other': 'checkout.validation.Other',
	'checkout.validation.InvalidDeliveryWindow': 'checkout.validation.InvalidDeliveryWindow',
	'checkout.validation.ExpressCheckoutInvalidDeliveryWindow': 'checkout.validation.ExpressCheckoutInvalidDeliveryWindow',
	'checkout.error.generic': 'checkout.error.generic',
	'checkout.error.vippsCancelled': 'checkout.error.vippsCancelled',
	'checkout.error.errorSettingServicePoint': 'checkout.error.errorSettingServicePoint',
	'checkout.error.unexpected': 'checkout.error.unexpected',
	'checkout.error.unexpectedCheckout': 'checkout.error.unexpectedCheckout',
	'checkout.error.refresh': 'checkout.error.refresh',
	'checkout.error.invalidActionPleaseRefresh': 'checkout.error.invalidActionPleaseRefresh',
	'checkout.error.invalidDeliveryWindow': 'checkout.error.invalidDeliveryWindow',
	'checkout.notCharged': 'checkout.notCharged',
	'orderSummary.name': 'orderSummary.name',
	'orderSummary.thankYouHeader': 'orderSummary.thankYouHeader',
	'orderSummary.emailConfirmation': 'orderSummary.emailConfirmation',
	'orderSummary.emailConfirmationFallback': 'orderSummary.emailConfirmationFallback',
	'orderSummary.contactCustomerService': 'orderSummary.contactCustomerService',
	'orderSummary.customerService': 'orderSummary.customerService',
	'orderSummary.orderNumber': 'orderSummary.orderNumber',
	'orderSummary.orderDate': 'orderSummary.orderDate',
	'orderSummary.deliveryDate': 'orderSummary.deliveryDate',
	'orderSummary.orderStatus': 'orderSummary.orderStatus',
	'orderSummary.paymentMethod': 'orderSummary.paymentMethod',
	'orderSummary.complaint': 'orderSummary.complaint',
	'orderSummary.cancelOrder': 'orderSummary.cancelOrder',
	'orderSummary.heading': 'orderSummary.heading',
	'orderSummary.package': 'orderSummary.package',
	'orderSummary.specialItems': 'orderSummary.specialItems',
	'orderSummary.sum': 'orderSummary.sum',
	'orderSummary.of': 'orderSummary.of',
	'orderSummary.before': 'orderSummary.before',
	'orderSummary.personalPickup': 'orderSummary.personalPickup',
	'orderSummary.deliveryAddress': 'orderSummary.deliveryAddress',
	'orderSummary.packageTracking': 'orderSummary.packageTracking',
	'orderSummary.cancel': 'orderSummary.cancel',
	'orderSummary.delivery': 'orderSummary.delivery',
	'orderSummary.freeDelivery': 'orderSummary.freeDelivery',
	'orderSummary.discount': 'orderSummary.discount',
	'orderSummary.discountCode': 'orderSummary.discountCode',
	'orderSummary.replacement': 'orderSummary.replacement',
	'orderSummary.priceAdjustment': 'orderSummary.priceAdjustment',
	'orderSummary.total': 'orderSummary.total',
	'orderSummary.includeTax': 'orderSummary.includeTax',
	'orderSummary.summary': 'orderSummary.summary',
	'orderSummary.waitingToBeShipped': 'orderSummary.waitingToBeShipped',
	'orderSummary.cancelledProducts': 'orderSummary.cancelledProducts',
	'orderSummary.productCancelled': 'orderSummary.productCancelled',
	'orderSummary.paymentTypes.card': 'orderSummary.paymentTypes.card',
	'orderSummary.paymentTypes.vipps': 'orderSummary.paymentTypes.vipps',
	'orderSummary.paymentTypes.other': 'orderSummary.paymentTypes.other',
	'orderSummary.paymentTypes.klarna': 'orderSummary.paymentTypes.klarna',
	'orderSummary.invoices.notReady': 'orderSummary.invoices.notReady',
	'orderSummary.invoices.unavailable': 'orderSummary.invoices.unavailable',
	'orderSummary.invoices.invoice': 'orderSummary.invoices.invoice',
	'orderSummary.rateThisProduct': 'orderSummary.rateThisProduct',
	'orderSummary.paymentInfo': 'orderSummary.paymentInfo',
	'product.related': 'product.related',
	'product.interesting': 'product.interesting',
	'product.otherSearchedFor': 'product.otherSearchedFor',
	'product.before': 'product.before',
	'product.prescriptionImageAlt': 'product.prescriptionImageAlt',
	'product.myPrescriptions': 'product.myPrescriptions',
	'product.notAvailable': 'product.notAvailable',
	'product.prescriptionMessage': 'product.prescriptionMessage',
	'product.outOfStockMessage': 'product.outOfStockMessage',
	'product.notAvailableMessage': 'product.notAvailableMessage',
	'product.ageOfConsentMessage': 'product.ageOfConsentMessage',
	'product.coldProductMessage': 'product.coldProductMessage',
	'product.freeDelivery': 'product.freeDelivery',
	'product.deliveryFrom': 'product.deliveryFrom',
	'product.validUntil': 'product.validUntil',
	'product.explore': 'product.explore',
	'product.previous': 'product.previous',
	'product.next': 'product.next',
	'product.availabilityNotification.heading': 'product.availabilityNotification.heading',
	'product.availabilityNotification.subheading': 'product.availabilityNotification.subheading',
	'product.availabilityNotification.modalHeading': 'product.availabilityNotification.modalHeading',
	'product.availabilityNotification.modalSubheading': 'product.availabilityNotification.modalSubheading',
	'product.availabilityNotification.button': 'product.availabilityNotification.button',
	'product.availabilityNotification.modalButton': 'product.availabilityNotification.modalButton',
	'product.availabilityNotification.privacyPolicyText': 'product.availabilityNotification.privacyPolicyText',
	'product.availabilityNotification.privacyPolicyLink': 'product.availabilityNotification.privacyPolicyLink',
	'product.availabilityNotification.savedHeading': 'product.availabilityNotification.savedHeading',
	'product.availabilityNotification.savedSubheading': 'product.availabilityNotification.savedSubheading',
	'product.availabilityNotification.incorrectEmail': 'product.availabilityNotification.incorrectEmail',
	'product.availabilityNotification.unexpectedError': 'product.availabilityNotification.unexpectedError',
	'productAvailability.InStock': 'productAvailability.InStock',
	'productAvailability.LowInStock': 'productAvailability.LowInStock',
	'productAvailability.OnDemand': 'productAvailability.OnDemand',
	'productAvailability.NotInStock': 'productAvailability.NotInStock',
	'productAvailability.PhysicalStoreOnly': 'productAvailability.PhysicalStoreOnly',
	'productAvailability.TemporarySalesStop': 'productAvailability.TemporarySalesStop',
	'productAvailability.NotInStockRxAdditionalInfo': 'productAvailability.NotInStockRxAdditionalInfo',
	'productAvailability.NotInStockNonRxRefundedAdditionalInfo': 'productAvailability.NotInStockNonRxRefundedAdditionalInfo',
	'productAvailability.OrderedRxAdditionalInfo': 'productAvailability.OrderedRxAdditionalInfo',
	'unavailabilityReason.Ok': 'unavailabilityReason.Ok',
	'unavailabilityReason.StatusNotWebReady': 'unavailabilityReason.StatusNotWebReady',
	'unavailabilityReason.NoPrice': 'unavailabilityReason.NoPrice',
	'unavailabilityReason.NoWeightOrDimensions': 'unavailabilityReason.NoWeightOrDimensions',
	'unavailabilityReason.NoInventory': 'unavailabilityReason.NoInventory',
	'unavailabilityReason.NotFound': 'unavailabilityReason.NotFound',
	'unavailabilityReason.WeightExceedsThreshold': 'unavailabilityReason.WeightExceedsThreshold',
	'unavailabilityReason.ExpiredInFarmalogg': 'unavailabilityReason.ExpiredInFarmalogg',
	'productCard.before': 'productCard.before',
	'productCard.discount': 'productCard.discount',
	'productCard.prescription': 'productCard.prescription',
	'productInformation.showMore': 'productInformation.showMore',
	'productInformation.prescriptionProduct': 'productInformation.prescriptionProduct',
	'promotions.discountCodeText': 'promotions.discountCodeText',
	'promotions.freeItemsDiscountInfoType': 'promotions.freeItemsDiscountInfoType',
	'promotions.quantityItemsDiscountInfoType': 'promotions.quantityItemsDiscountInfoType',
	'promotions.quantityItemsDiscountText': 'promotions.quantityItemsDiscountText',
	'promotions.defaultDiscountText': 'promotions.defaultDiscountText',
	'addToCart.buy': 'addToCart.buy',
	'addToCart.buyWithGuidance': 'addToCart.buyWithGuidance',
	'addToCart.formWarning': 'addToCart.formWarning',
	'addToCart.errorMessage': 'addToCart.errorMessage',
	'addToCart.successfullyAdded': 'addToCart.successfullyAdded',
	'addToCart.unexpectedError': 'addToCart.unexpectedError',
	'addToCart.close': 'addToCart.close',
	'filters.category': 'filters.category',
	'filters.brand': 'filters.brand',
	'filters.subbrand': 'filters.subbrand',
	'filters.productType': 'filters.productType',
	'filters.skinType': 'filters.skinType',
	'filters.properties': 'filters.properties',
	'filters.form': 'filters.form',
	'filters.keyInformation': 'filters.keyInformation',
	'filters.audience': 'filters.audience',
	'filters.sunFactor': 'filters.sunFactor',
	'filters.taste': 'filters.taste',
	'filters.size': 'filters.size',
	'filters.material': 'filters.material',
	'filters.color': 'filters.color',
	'filters.strength': 'filters.strength',
	'filters.hairType': 'filters.hairType',
	'filters.calories': 'filters.calories',
	'filters.price': 'filters.price',
	'filters.priceDescription': 'filters.priceDescription',
	'sorting.ByDate': 'sorting.ByDate',
	'sorting.ByNewlyAdded': 'sorting.ByNewlyAdded',
	'sorting.ByRelevance': 'sorting.ByRelevance',
	'sorting.ByPriceAscending': 'sorting.ByPriceAscending',
	'sorting.ByPriceDescending': 'sorting.ByPriceDescending',
	'sorting.ByName': 'sorting.ByName',
	'sorting.ByPromotionPercentage': 'sorting.ByPromotionPercentage',
	'search.products': 'search.products',
	'search.categories': 'search.categories',
	'search.brands': 'search.brands',
	'search.seeAll': 'search.seeAll',
	'search.noResults': 'search.noResults',
	'search.seeRecommendations': 'search.seeRecommendations',
	'search.checkSpelling': 'search.checkSpelling',
	'search.phrases': 'search.phrases',
	'search.pharmacyAdvice': 'search.pharmacyAdvice',
	'productFilters.filters': 'productFilters.filters',
	'productFilters.open': 'productFilters.open',
	'productFilters.product': 'productFilters.product',
	'productFilters.products': 'productFilters.products',
	'productFilters.loading': 'productFilters.loading',
	'productFilters.searchResults': 'productFilters.searchResults',
	'productFilters.searchResultsWithoutFor': 'productFilters.searchResultsWithoutFor',
	'productFilters.clear': 'productFilters.clear',
	'productFilters.seeResults': 'productFilters.seeResults',
	'productFilters.noResults': 'productFilters.noResults',
	'productFilters.sortBy': 'productFilters.sortBy',
	'paging.previousPage': 'paging.previousPage',
	'paging.nextPage': 'paging.nextPage',
	'paging.currentPage': 'paging.currentPage',
	'paging.of': 'paging.of',
	'priceRange.from': 'priceRange.from',
	'priceRange.to': 'priceRange.to',
	'displayAttributes.warranty': 'displayAttributes.warranty',
	'displayAttributes.productInfo': 'displayAttributes.productInfo',
	'displayAttributes.ingredients': 'displayAttributes.ingredients',
	'displayAttributes.tabletPicture': 'displayAttributes.tabletPicture',
	'displayAttributes.contentDeclaration': 'displayAttributes.contentDeclaration',
	'displayAttributes.activeIngredient': 'displayAttributes.activeIngredient',
	'displayAttributes.usageAndDosage': 'displayAttributes.usageAndDosage',
	'displayAttributes.subscriptionLink': 'displayAttributes.subscriptionLink',
	'displayAttributes.manufacturerLink': 'displayAttributes.manufacturerLink',
	'displayAttributes.resourceLink': 'displayAttributes.resourceLink',
	'displayAttributes.dosage': 'displayAttributes.dosage',
	'displayAttributes.precautions': 'displayAttributes.precautions',
	'displayAttributes.pregnancyNotice': 'displayAttributes.pregnancyNotice',
	'displayAttributes.warningSign': 'displayAttributes.warningSign',
	'displayAttributes.canBeShared': 'displayAttributes.canBeShared',
	'displayAttributes.nutritionalContent': 'displayAttributes.nutritionalContent',
	'displayAttributes.canBeCrushed': 'displayAttributes.canBeCrushed',
	'displayAttributes.storageConditions': 'displayAttributes.storageConditions',
	'displayAttributes.dangerousGoods': 'displayAttributes.dangerousGoods',
	'displayAttributes.leafletLink': 'displayAttributes.leafletLink',
	'displayAttributes.flavor': 'displayAttributes.flavor',
	'displayAttributes.classification': 'displayAttributes.classification',
	'displayAttributes.tabletPictureLink': 'displayAttributes.tabletPictureLink',
	'displayAttributes.manufacturerLeaflet': 'displayAttributes.manufacturerLeaflet',
	'displayAttributes.productNumber': 'displayAttributes.productNumber',
	'displayAttributes.farmaloggNumber': 'displayAttributes.farmaloggNumber',
	'displayAttributes.additionalResource': 'displayAttributes.additionalResource',
	'displayAttributes.additionalResourceHeader': 'displayAttributes.additionalResourceHeader',
	'displayAttributes.yes': 'displayAttributes.yes',
	'displayAttributes.no': 'displayAttributes.no',
	'selectedOptionList.removeAll': 'selectedOptionList.removeAll',
	'cookiesConsent.acceptButtonLabel': 'cookiesConsent.acceptButtonLabel',
	'mainBanner.readMore': 'mainBanner.readMore',
	'alertRibbon.close': 'alertRibbon.close',
	'info.readMore': 'info.readMore',
	'brandPage.readMore': 'brandPage.readMore',
	'brandPage.exploreBrands': 'brandPage.exploreBrands',
	'categoryPage.readMore': 'categoryPage.readMore',
	'mainBannerGallery.next': 'mainBannerGallery.next',
	'mainBannerGallery.previous': 'mainBannerGallery.previous',
	'viagraForm.heading': 'viagraForm.heading',
	'viagraForm.validation': 'viagraForm.validation',
	'viagraForm.gender': 'viagraForm.gender',
	'viagraForm.man': 'viagraForm.man',
	'viagraForm.woman': 'viagraForm.woman',
	'viagraForm.onlyForMan': 'viagraForm.onlyForMan',
	'viagraForm.yes': 'viagraForm.yes',
	'viagraForm.no': 'viagraForm.no',
	'viagraForm.contactUs': 'viagraForm.contactUs',
	'viagraForm.discuss': 'viagraForm.discuss',
	'viagraForm.anyOfFollowing': 'viagraForm.anyOfFollowing',
	'viagraForm.lowBloodPressure': 'viagraForm.lowBloodPressure',
	'viagraForm.lowBloodPressureExplanation': 'viagraForm.lowBloodPressureExplanation',
	'viagraForm.highBloodPressure': 'viagraForm.highBloodPressure',
	'viagraForm.highBloodPressureExplanation': 'viagraForm.highBloodPressureExplanation',
	'viagraForm.angina': 'viagraForm.angina',
	'viagraForm.anginaExplanation': 'viagraForm.anginaExplanation',
	'viagraForm.irregularHeartbeats': 'viagraForm.irregularHeartbeats',
	'viagraForm.irregularHeartbeatsExplanation': 'viagraForm.irregularHeartbeatsExplanation',
	'viagraForm.anticonvulsantMedicines': 'viagraForm.anticonvulsantMedicines',
	'viagraForm.anticonvulsantMedicinesExplanation': 'viagraForm.anticonvulsantMedicinesExplanation',
	'viagraForm.readMoreAboutHeartCramps': 'viagraForm.readMoreAboutHeartCramps',
	'viagraForm.heartAttack': 'viagraForm.heartAttack',
	'viagraForm.heartAttackExplanation': 'viagraForm.heartAttackExplanation',
	'viagraForm.poppers': 'viagraForm.poppers',
	'viagraForm.poppersExplanation': 'viagraForm.poppersExplanation',
	'viagraForm.adempas': 'viagraForm.adempas',
	'viagraForm.adempasExplanation': 'viagraForm.adempasExplanation',
	'viagraForm.ritonavir': 'viagraForm.ritonavir',
	'viagraForm.ritonavirExplanation': 'viagraForm.ritonavirExplanation',
	'viagraForm.opticDamage': 'viagraForm.opticDamage',
	'viagraForm.opticDamageExplanation': 'viagraForm.opticDamageExplanation',
	'viagraForm.guidance': 'viagraForm.guidance',
	'viagraForm.guidanceSubText': 'viagraForm.guidanceSubText',
	'viagraForm.addToCart': 'viagraForm.addToCart',
	'viagraForm.continue': 'viagraForm.continue',
	'viagraForm.contactWithDoctor': 'viagraForm.contactWithDoctor',
	'viagraForm.answerAllQuestions': 'viagraForm.answerAllQuestions',
	'viagraForm.required': 'viagraForm.required',
	'viagraForm.explanation': 'viagraForm.explanation',
	'viagraForm.checkbox': 'viagraForm.checkbox',
	'viagraForm.zenDeskUnavailable': 'viagraForm.zenDeskUnavailable',
	'duraphatForm.header': 'duraphatForm.header',
	'duraphatForm.close': 'duraphatForm.close',
	'duraphatForm.ageConsent': 'duraphatForm.ageConsent',
	'duraphatForm.cavities': 'duraphatForm.cavities',
	'duraphatForm.visibleRoots': 'duraphatForm.visibleRoots',
	'duraphatForm.hygieneDifficulties': 'duraphatForm.hygieneDifficulties',
	'duraphatForm.dryMouth': 'duraphatForm.dryMouth',
	'duraphatForm.importantInformation': 'duraphatForm.importantInformation',
	'duraphatForm.orSee': 'duraphatForm.orSee',
	'duraphatForm.QA': 'duraphatForm.QA',
	'duraphatForm.contact': 'duraphatForm.contact',
	'duraphatForm.buy': 'duraphatForm.buy',
	'duraphatForm.confirm': 'duraphatForm.confirm',
	'email.subject.RegistrationMessage': 'email.subject.RegistrationMessage',
	'email.subject.ResetPasswordRequestedMessage': 'email.subject.ResetPasswordRequestedMessage',
	'email.subject.SetPasswordOnFirstLoginMessage': 'email.subject.SetPasswordOnFirstLoginMessage',
	'email.subject.ResetPasswordOnLockoutMessage': 'email.subject.ResetPasswordOnLockoutMessage',
	'email.subject.OrderCancelledMessage': 'email.subject.OrderCancelledMessage',
	'email.subject.OrderLineCancelledMessage': 'email.subject.OrderLineCancelledMessage',
	'email.subject.OrderPlacedConfirmationMessage': 'email.subject.OrderPlacedConfirmationMessage',
	'email.subject.SalesInvoiceCreated': 'email.subject.SalesInvoiceCreated',
	'email.subject.PackageSentMessage': 'email.subject.PackageSentMessage',
	'email.subject.ReturnOrderCreatedMessage': 'email.subject.ReturnOrderCreatedMessage',
	'email.subject.OrderDetailsMessage': 'email.subject.OrderDetailsMessage',
	'email.otherPayment': 'email.otherPayment',
	'email.unknownDeliveryMode': 'email.unknownDeliveryMode',
	'errorPage.error': 'errorPage.error',
	'errorPage.backToHome': 'errorPage.backToHome',
	'errorPage.code400.heading': 'errorPage.code400.heading',
	'errorPage.code401.heading': 'errorPage.code401.heading',
	'errorPage.code402.heading': 'errorPage.code402.heading',
	'errorPage.code403.heading': 'errorPage.code403.heading',
	'errorPage.code403.description': 'errorPage.code403.description',
	'errorPage.code404.heading': 'errorPage.code404.heading',
	'errorPage.code404.description': 'errorPage.code404.description',
	'errorPage.code405.heading': 'errorPage.code405.heading',
	'errorPage.code406.heading': 'errorPage.code406.heading',
	'errorPage.code407.heading': 'errorPage.code407.heading',
	'errorPage.code408.heading': 'errorPage.code408.heading',
	'errorPage.code410.heading': 'errorPage.code410.heading',
	'errorPage.code411.heading': 'errorPage.code411.heading',
	'errorPage.code501.heading': 'errorPage.code501.heading',
	'errorPage.code502.heading': 'errorPage.code502.heading',
	'errorPage.code503.heading': 'errorPage.code503.heading',
	'errorPage.code504.heading': 'errorPage.code504.heading',
	'errorPage.code505.heading': 'errorPage.code505.heading',
	'userProfile.name': 'userProfile.name',
	'userProfile.welcome': 'userProfile.welcome',
	'userProfile.loggedIn': 'userProfile.loggedIn',
	'userProfile.logOut': 'userProfile.logOut',
	'userProfile.contactCustomerService': 'userProfile.contactCustomerService',
	'userProfile.customerService': 'userProfile.customerService',
	'userProfile.edit': 'userProfile.edit',
	'userProfile.confirm': 'userProfile.confirm',
	'userProfile.cancel': 'userProfile.cancel',
	'userProfile.changePassword.myPassword': 'userProfile.changePassword.myPassword',
	'userProfile.changePassword.CurrentPassword': 'userProfile.changePassword.CurrentPassword',
	'userProfile.changePassword.NewPassword': 'userProfile.changePassword.NewPassword',
	'userProfile.changePassword.ConfirmPassword': 'userProfile.changePassword.ConfirmPassword',
	'userProfile.changePassword.successful': 'userProfile.changePassword.successful',
	'userProfile.changePassword.errors.fieldRequired': 'userProfile.changePassword.errors.fieldRequired',
	'userProfile.changePassword.errors.passwordsNotMatch': 'userProfile.changePassword.errors.passwordsNotMatch',
	'userProfile.cookies.title': 'userProfile.cookies.title',
	'userProfile.cookies.necessary': 'userProfile.cookies.necessary',
	'userProfile.cookies.preferences': 'userProfile.cookies.preferences',
	'userProfile.cookies.statistics': 'userProfile.cookies.statistics',
	'userProfile.cookies.marketing': 'userProfile.cookies.marketing',
	'userProfile.userInformation.heading': 'userProfile.userInformation.heading',
	'userProfile.userInformation.firstName': 'userProfile.userInformation.firstName',
	'userProfile.userInformation.lastName': 'userProfile.userInformation.lastName',
	'userProfile.userInformation.email': 'userProfile.userInformation.email',
	'userProfile.userInformation.phone': 'userProfile.userInformation.phone',
	'userProfile.userInformation.errors.fieldRequired': 'userProfile.userInformation.errors.fieldRequired',
	'userProfile.userInformation.errors.email': 'userProfile.userInformation.errors.email',
	'userProfile.userInformation.errors.phone': 'userProfile.userInformation.errors.phone',
	'userProfile.userInformation.errors.firstNameToLong': 'userProfile.userInformation.errors.firstNameToLong',
	'userProfile.userInformation.errors.lastNameToLong': 'userProfile.userInformation.errors.lastNameToLong',
	'userProfile.userInformation.errors.firstNameWrongCharacters': 'userProfile.userInformation.errors.firstNameWrongCharacters',
	'userProfile.userInformation.errors.lastNameWrongCharacters': 'userProfile.userInformation.errors.lastNameWrongCharacters',
	'userProfile.userInformation.errors.incorrectValue': 'userProfile.userInformation.errors.incorrectValue',
	'userProfile.marketingConsents.heading': 'userProfile.marketingConsents.heading',
	'userProfile.marketingConsents.discounts': 'userProfile.marketingConsents.discounts',
	'userProfile.marketingConsents.SMS': 'userProfile.marketingConsents.SMS',
	'userProfile.marketingConsents.email': 'userProfile.marketingConsents.email',
	'userProfile.marketingConsents.newsletter': 'userProfile.marketingConsents.newsletter',
	'userProfile.marketingConsents.reviews': 'userProfile.marketingConsents.reviews',
	'userProfile.marketingConsents.abandonedCarts': 'userProfile.marketingConsents.abandonedCarts',
	'userProfile.marketingConsents.errors.serviceUnavailable': 'userProfile.marketingConsents.errors.serviceUnavailable',
	'userProfile.marketingConsents.errors.updateFailed': 'userProfile.marketingConsents.errors.updateFailed',
	'userProfile.addresses.myAddresses': 'userProfile.addresses.myAddresses',
	'userProfile.addresses.addNewAddress': 'userProfile.addresses.addNewAddress',
	'userProfile.orderHistory.emptyTitle': 'userProfile.orderHistory.emptyTitle',
	'userProfile.orderHistory.emptySubtitle1': 'userProfile.orderHistory.emptySubtitle1',
	'userProfile.orderHistory.emptySubtitle2': 'userProfile.orderHistory.emptySubtitle2',
	'userProfile.orderHistory.emptyButton': 'userProfile.orderHistory.emptyButton',
	'userProfile.orderHistory.noConnectionTitle': 'userProfile.orderHistory.noConnectionTitle',
	'userProfile.orderHistory.noConnectionSubtitle1': 'userProfile.orderHistory.noConnectionSubtitle1',
	'userProfile.orderHistory.noConnectionSubtitle2': 'userProfile.orderHistory.noConnectionSubtitle2',
	'userProfile.orderHistory.orderNumber': 'userProfile.orderHistory.orderNumber',
	'userProfile.orderHistory.orderDate': 'userProfile.orderHistory.orderDate',
	'userProfile.orderHistory.package': 'userProfile.orderHistory.package',
	'userProfile.orderHistory.of': 'userProfile.orderHistory.of',
	'userProfile.orderHistory.send': 'userProfile.orderHistory.send',
	'userProfile.orderHistory.packageTracking': 'userProfile.orderHistory.packageTracking',
	'userProfile.orderHistory.statusText': 'userProfile.orderHistory.statusText',
	'userProfile.orderHistory.cannotFindOrder': 'userProfile.orderHistory.cannotFindOrder',
	'userProfile.orderHistory.prescriptionHistory': 'userProfile.orderHistory.prescriptionHistory',
	'userProfile.orderHistory.quantity': 'userProfile.orderHistory.quantity',
	'userProfile.orderHistory.paging.firstPage': 'userProfile.orderHistory.paging.firstPage',
	'userProfile.orderHistory.paging.previousPage': 'userProfile.orderHistory.paging.previousPage',
	'userProfile.orderHistory.paging.nextPage': 'userProfile.orderHistory.paging.nextPage',
	'userProfile.orderHistory.orderStatus.processing': 'userProfile.orderHistory.orderStatus.processing',
	'userProfile.orderHistory.orderStatus.unknown': 'userProfile.orderHistory.orderStatus.unknown',
	'userProfile.orderHistory.orderStatus.created': 'userProfile.orderHistory.orderStatus.created',
	'userProfile.orderHistory.orderStatus.backorder': 'userProfile.orderHistory.orderStatus.backorder',
	'userProfile.orderHistory.orderStatus.delivered': 'userProfile.orderHistory.orderStatus.delivered',
	'userProfile.orderHistory.orderStatus.invoiced': 'userProfile.orderHistory.orderStatus.invoiced',
	'userProfile.orderHistory.orderStatus.confirmed': 'userProfile.orderHistory.orderStatus.confirmed',
	'userProfile.orderHistory.orderStatus.sent': 'userProfile.orderHistory.orderStatus.sent',
	'userProfile.orderHistory.orderStatus.lost': 'userProfile.orderHistory.orderStatus.lost',
	'userProfile.orderHistory.orderStatus.canceled': 'userProfile.orderHistory.orderStatus.canceled',
	'userProfile.orderHistory.orderStatus.return': 'userProfile.orderHistory.orderStatus.return',
	'userProfile.orderHistory.orderLineStatus.processing': 'userProfile.orderHistory.orderLineStatus.processing',
	'userProfile.orderHistory.orderLineStatus.unknown': 'userProfile.orderHistory.orderLineStatus.unknown',
	'userProfile.orderHistory.orderLineStatus.created': 'userProfile.orderHistory.orderLineStatus.created',
	'userProfile.orderHistory.orderLineStatus.backorder': 'userProfile.orderHistory.orderLineStatus.backorder',
	'userProfile.orderHistory.orderLineStatus.delivered': 'userProfile.orderHistory.orderLineStatus.delivered',
	'userProfile.orderHistory.orderLineStatus.invoiced': 'userProfile.orderHistory.orderLineStatus.invoiced',
	'userProfile.orderHistory.orderLineStatus.confirmed': 'userProfile.orderHistory.orderLineStatus.confirmed',
	'userProfile.orderHistory.orderLineStatus.sent': 'userProfile.orderHistory.orderLineStatus.sent',
	'userProfile.orderHistory.orderLineStatus.lost': 'userProfile.orderHistory.orderLineStatus.lost',
	'userProfile.orderHistory.orderLineStatus.canceled': 'userProfile.orderHistory.orderLineStatus.canceled',
	'userProfile.orderHistory.orderLineStatus.return': 'userProfile.orderHistory.orderLineStatus.return',
	'userProfile.orderHistory.orderLineType.cancellation': 'userProfile.orderHistory.orderLineType.cancellation',
	'userProfile.orderHistory.orderLineType.refund': 'userProfile.orderHistory.orderLineType.refund',
	'userProfile.orderHistory.orderLineType.priceAdjustment': 'userProfile.orderHistory.orderLineType.priceAdjustment',
	'form.successMessage': 'form.successMessage',
	'form.errors.required': 'form.errors.required',
	'form.errors.minLength': 'form.errors.minLength',
	'form.errors.maxLength': 'form.errors.maxLength',
	'form.errors.sameValueAs': 'form.errors.sameValueAs',
	'form.errors.badRequest': 'form.errors.badRequest',
	'form.errors.email': 'form.errors.email',
	'form.buttons.confirm': 'form.buttons.confirm',
	'form.buttons.cancel': 'form.buttons.cancel',
	'form.show': 'form.show',
	'form.requiredFields': 'form.requiredFields',
	'cheapestForFreeDiscount.for': 'cheapestForFreeDiscount.for',
	'productDiscount.upTo': 'productDiscount.upTo',
	'contentName.checkout': 'contentName.checkout',
	'contentName.search': 'contentName.search',
	'contentName.home': 'contentName.home',
	'contentName.error': 'contentName.error',
	'contentName.newsletter.unsubscribe': 'contentName.newsletter.unsubscribe',
	'enum.infoBanner.none': 'enum.infoBanner.none',
	'enum.infoBanner.newItem': 'enum.infoBanner.newItem',
	'enum.infoBanner.vegan': 'enum.infoBanner.vegan',
	'enum.infoBanner.bestseller': 'enum.infoBanner.bestseller',
	'enum.infoBanner.lowPrice1': 'enum.infoBanner.lowPrice1',
	'enum.infoBanner.lowPrice2': 'enum.infoBanner.lowPrice2',
	'enum.infoBanner.goodPurchase1': 'enum.infoBanner.goodPurchase1',
	'enum.infoBanner.goodPurchase2': 'enum.infoBanner.goodPurchase2',
	'enum.ProductListVariant.GridWithSwiper': 'enum.ProductListVariant.GridWithSwiper',
	'enum.ProductListVariant.Horizontal': 'enum.ProductListVariant.Horizontal',
	'enum.ProductListVariant.GridWithoutSwiper': 'enum.ProductListVariant.GridWithoutSwiper',
	'enum.ProductListVariant.None': 'enum.ProductListVariant.None',
	'enum.ProductListVariant.CartHorizontal': 'enum.ProductListVariant.CartHorizontal',
	'enum.BannerBackgroundVariant.Pink': 'enum.BannerBackgroundVariant.Pink',
	'enum.BannerBackgroundVariant.PinkWithRedBorderInside': 'enum.BannerBackgroundVariant.PinkWithRedBorderInside',
	'enum.BannerBackgroundVariant.PinkWithBlackBorderInside': 'enum.BannerBackgroundVariant.PinkWithBlackBorderInside',
	'enum.BannerBackgroundVariant.Blue': 'enum.BannerBackgroundVariant.Blue',
	'enum.BannerBackgroundVariant.BlueWithBlackBorderInside': 'enum.BannerBackgroundVariant.BlueWithBlackBorderInside',
	'enum.BannerBackgroundVariant.WhiteWithRedBorder': 'enum.BannerBackgroundVariant.WhiteWithRedBorder',
	'enum.textBannerBackgroundVariant.Pink': 'enum.textBannerBackgroundVariant.Pink',
	'enum.textBannerBackgroundVariant.Blue': 'enum.textBannerBackgroundVariant.Blue',
	'enum.textBannerBackgroundVariant.Red': 'enum.textBannerBackgroundVariant.Red',
	'enum.textBannerBackgroundVariant.Black': 'enum.textBannerBackgroundVariant.Black',
	'enum.textColor.black': 'enum.textColor.black',
	'enum.textColor.white': 'enum.textColor.white',
	'enum.linkListColumnVariant.twoColumns': 'enum.linkListColumnVariant.twoColumns',
	'enum.linkListColumnVariant.fourColumns': 'enum.linkListColumnVariant.fourColumns',
	'enum.linkListBackgroundVariant.Grey': 'enum.linkListBackgroundVariant.Grey',
	'enum.linkListBackgroundVariant.Pink': 'enum.linkListBackgroundVariant.Pink',
	'enum.linkListBackgroundVariant.Blue': 'enum.linkListBackgroundVariant.Blue',
	'enum.textHeroBackgroundVariant.Pink': 'enum.textHeroBackgroundVariant.Pink',
	'enum.textHeroBackgroundVariant.pinkWithRedBorderInside': 'enum.textHeroBackgroundVariant.pinkWithRedBorderInside',
	'enum.textHeroBackgroundVariant.Black': 'enum.textHeroBackgroundVariant.Black',
	'enum.IdentityErrorCode.DefaultError': 'enum.IdentityErrorCode.DefaultError',
	'enum.IdentityErrorCode.PasswordMismatch': 'enum.IdentityErrorCode.PasswordMismatch',
	'enum.IdentityErrorCode.PasswordTooShort': 'enum.IdentityErrorCode.PasswordTooShort',
	'enum.IdentityErrorCode.PasswordRequiresDigit': 'enum.IdentityErrorCode.PasswordRequiresDigit',
	'enum.IdentityErrorCode.PasswordRequiresLower': 'enum.IdentityErrorCode.PasswordRequiresLower',
	'enum.IdentityErrorCode.PasswordRequiresUpper': 'enum.IdentityErrorCode.PasswordRequiresUpper',
	'enum.ImageSize.Size1920x240': 'enum.ImageSize.Size1920x240',
	'enum.ImageSize.Size1920x400': 'enum.ImageSize.Size1920x400',
	'enum.ImageSize.Size1260x400': 'enum.ImageSize.Size1260x400',
	'newsletter.AddedToRecipientList': 'newsletter.AddedToRecipientList',
	'newsletter.RemovedFromUnsubscribedList': 'newsletter.RemovedFromUnsubscribedList',
	'newsletter.RecipientIsEitherBlacklistedOrExceededBounceLimit': 'newsletter.RecipientIsEitherBlacklistedOrExceededBounceLimit',
	'newsletter.AlreadySubscribed': 'newsletter.AlreadySubscribed',
	'newsletter.ServerError': 'newsletter.ServerError',
	'newsletter.subscriptionConfirmed': 'newsletter.subscriptionConfirmed',
	'newsletter.backToMainPage': 'newsletter.backToMainPage',
	'newsletter.SignUpAgain': 'newsletter.SignUpAgain',
	'newsletter.UnsubscribeReasonNotSelected': 'newsletter.UnsubscribeReasonNotSelected',
	'newsletter.send': 'newsletter.send',
	'newsletter.EmailPlaceholder': 'newsletter.EmailPlaceholder',
	'newsletter.SignUp': 'newsletter.SignUp',
	'newsletter.LackOfConsent': 'newsletter.LackOfConsent',
	'newsletter.InvalidEmail': 'newsletter.InvalidEmail',
	'newsletter.UnexpectedError': 'newsletter.UnexpectedError',
	'newsletter.UnknownError': 'newsletter.UnknownError',
	'newsletter.DidYouMean': 'newsletter.DidYouMean',
	'newsletter.AreYouSure': 'newsletter.AreYouSure',
	'productNotifications.title': 'productNotifications.title',
	'productNotifications.subtitle': 'productNotifications.subtitle',
	'emailSuggestion.header': 'emailSuggestion.header',
	'emailSuggestion.incorrectAddress': 'emailSuggestion.incorrectAddress',
	'emailSuggestion.didYouMeanToUse': 'emailSuggestion.didYouMeanToUse',
	'emailSuggestion.withSuggestionRejectButton': 'emailSuggestion.withSuggestionRejectButton',
	'emailSuggestion.withoutSuggestionRejectButton': 'emailSuggestion.withoutSuggestionRejectButton',
	'emailSuggestion.withSuggestionAcceptButton': 'emailSuggestion.withSuggestionAcceptButton',
	'emailSuggestion.withoutSuggestionAcceptButton': 'emailSuggestion.withoutSuggestionAcceptButton',
	'emailSuggestion.areYouSure': 'emailSuggestion.areYouSure',
	'powerReviews.writeAReview': 'powerReviews.writeAReview',
	'powerReviews.reviewYourPurchase': 'powerReviews.reviewYourPurchase',
	'klarna.orderNumber': 'klarna.orderNumber',
	'klarna.refund': 'klarna.refund',
	'klarna.invoiceId': 'klarna.invoiceId',
	'klarna.shipment': 'klarna.shipment',
	'klarna.rxLineItemName': 'klarna.rxLineItemName',
	'klarna.otcLineItemName': 'klarna.otcLineItemName',
	'klarna.tgLineItemName': 'klarna.tgLineItemName',
	'errorMessageBar.close': 'errorMessageBar.close',
	'errorMessageBar.defaultMessage': 'errorMessageBar.defaultMessage',
	'bankId.yourSecureSession': 'bankId.yourSecureSession',
	'prescriptionHistory.downloadPrescriptionHistory': 'prescriptionHistory.downloadPrescriptionHistory',
}
export var translations : ITranslations;
export function setTranslations(languageTranslations: ITranslations) {
	translations = languageTranslations;
}
export function getTranslation(translationPath: string, args: any[] = []): string {
	const trans: any = translations;
	return format(trans ? trans[translationPath] : '', args);
}
export function getTranslationWithFallback(translationPath: string, fallback: string, args: any[] = []): string {
	const trans: any = translations;
	return format((trans && trans[translationPath]) ? trans[translationPath] : fallback, args);
}
function format(text: string, args: any[]) {
	if (!text || !args?.length) {
		return text;
	}
	return text.replace(/{(\d+)}/g, (match, number) => typeof args[number] != 'undefined' ? args[number] : match);
}
declare var global: any;
global.setTranslations = setTranslations;
